import moment from "moment";
import React, { useEffect, useState, useMemo, useRef } from "react";
import { useLocation, useHistory } from "react-router-dom";
import InformationComponentFix from "../../components/RequestComponents/InformationComponent/InformationComponentFix";
import { useUserContext } from "../../Context/UserContext";
import useLoading from "../../hooks/useLoading";
import { IMemoButtonModel } from "../../IRequestModel/IMemoButtonModel";
import { IMemoDetailModel } from "../../IRequestModel/IMemoDetailModel";
import { useTranslation } from "react-i18next";
import { GetMemoAuthorized } from "../../Services/AuthorizedService";
import { dataCompany } from "../../Services/CompanyService";
import { GetAllEmployee } from "../../Services/EmployeeService";
import { Button } from "antd";
import {
  ActionMemoPage,
  GetButtonMemoByMemoId,
  GetMemoDetail,
  GetMemoDetailOnlyById,
  GetMemoHistoryDetail,
  GetRefDocTemp,
  SpecialActions,
  GetMemoByAutoNumber,
} from "../../Services/MemoService";
import {
  GetTemplateByDocTypeCode,
  GetTemplateById,
  LoadLogic,
  SearchTemplateListEditing,
} from "../../Services/TemplateService";
import { IoMenu } from "react-icons/io5";
import { TreeSelectNewRequest } from "../../components/TreeSelectNewRequest/TreeSelectNewRequest";
import RequestSideBarElement from "./RequestSideBarElement";
import LineApprovalsComponentFix from "../../components/RequestComponents/LineApprovalsComponent/LineApprovalsComponentFix";
import AttachmentComponent from "../../components/RequestComponents/AttachmentComponent/AttachmentComponent";
import { HistoryComponent } from "../../components/RequestComponents/HistoryComponent/HistoryComponent";
import { RequestorComponent } from "../../components/RequestComponents/RequestorComponent/RequestorComponent";
import { useForm } from "react-hook-form";
import { GetAllProject } from "../../Services/ProjectService";
import { generateQuickGuid } from "../../Helper/GenerateGuid";
import { ADTitleConfiguration } from "../../Services/ConfigurationService";
import {
  GetLeaveTemplateByEmpId,
  GetMasterDataByTypeNames,
  getVersionTempVC,
} from "../../Services/MasterDataService";
import { OtherButtonMemoComponent } from "../../components/MemoButton/MemoButtonetcComponent";

import { formatKeyLogicData } from "../../Helper/formatKeyLogicData";
import {
  ILogic,
  ILogicReferenceField,
  ILogicTypeShowHide,
  ILogicTypeReference,
  ILogicTypeReladToLoadData,
  ILogicTypeSpecialAction,
  ILogicTypeDataLineApprove,
  ILogicReferenceInformation,
  ILogicTypeSourceRelated,
  ILogicTypeHideControl,
  ILogicTypeReadOnly,
} from "../../IRequestModel/ILogicModel";

import { MemoSingleButton } from "../../components/MemoButton/MemoSingleButton";
import { MemoButtonComponent } from "../../components/MemoButton/MemoButtonComponent";
import { IRequestOnSubmit } from "../../IRequestModel/CreateFormControl/IRequestOnSubmit";

import { Toast } from "primereact/toast";
import { Validation } from "../../Helper/Validation";
import { IUserModel } from "../../IRequestModel/IUserModel";
import { INumberFormula } from "../../IRequestModel/INumberFormula";
import { IAutoNumberAttibute } from "../../IRequestModel/IAutoNumberFormat";
import {
  GetRvsRunning,
  GetSaveRunningNumber,
  CanAssignMoreThanOne,
  CanRequestCommentMoreThanOne,
} from "../../Services/RequestControlService";
import { GetRolePermissionByUser } from "../../Services/RoleServices";
import {
  IApprovaReadHide,
  IListApprovalDetailsModel,
  IReqConditions,
} from "../../IRequestModel/IListApprovalDetailsModel";
import { onLoadDataLiveApprove } from "../../Services/LineApprovalsService";
import {
  callGenAutoNumber,
  genAutoNum,
  getDefValueInTemplate,
  getRefInforValue,
  getValueControl,
} from "../../Helper/RequestScreenHelper";
import useAlert from "../../hooks/useAlert";
import useAdminEditCompletedMemoPermissionContext from "../../hooks/useAdminEditCompletedMemo";
import { IRolePermission } from "../../IRequestModel/IRolePermission";
import { motion, AnimatePresence } from "framer-motion";
import { isEmptyObject } from "jquery";
import { tableSelectOption } from "../../components/AntdControlComponent/TableComponent/TableComponent";
import { LogicOperatorType, LogicType } from "../../constants/logic-type";
import {
  checkIsCorrect,
  processHideControlLogic,
} from "../../Helper/LogicHelper";
import _, { property } from "lodash";
import { v4 as uuidv4 } from "uuid";
import useMasterSetting from "../../hooks/useMasterSetting";
import { useAppSettingContext } from "../../Context/AppSettingContext";

const RequestScreenFix = () => {
  const { toggleAlert } = useAlert();
  //PageSetting
  const tabSelect = sessionStorage.getItem("back");
  const [userData, setUserData] = useUserContext();
  const location = useLocation<any>();
  const isFirstRun = useRef(true);
  const toast = useRef<any>(null);
  const { isLoad, setLoad } = useLoading();
  const { search, pathname } = useLocation();
  const history = useHistory();
  const query = useMemo(() => new URLSearchParams(search), [search]);
  const [sidebarState, setSidebarState] = useState<boolean>(true);
  const [checkUseEffect, setCheckUseEffect] = useState<boolean>(false);
  const [checkActionPage, setCheckActionPage] = useState<string>("");
  const [checkedLeaveTemplate, setCheckedLeaveTemplate] = useState<boolean>();
  const [curPage, setCurPage] = useState<string>(tabSelect ? tabSelect : "2");
  const [selectedView, setSelectedView] = useState<string>(tabSelect ? tabSelect : "2");
  const [dataTreeSelectProps, setDataTreeSelectProps] = useState<any>({});
  const [isControlLoading, _setIsControlLoading] = useState(false);
  const [masterTemplateDesc, setMasterTemplateDesc] = useState<any>();
  const [actionAlert, setActionAlert] = useState<any>();
  const [isDirtyOfTable, setIsDirtyOfTable] = useState<any>({});

  let showLoadTimer: any = null;
  let hideLoadTimer: any = null;
  function setIsControlLoading(isShowLoad: boolean) {
    if (showLoadTimer !== null) {
      clearTimeout(showLoadTimer);
    }
    if (hideLoadTimer !== null) {
      clearTimeout(hideLoadTimer);
    }
    if (isShowLoad) {
      showLoadTimer = setTimeout(() => _setIsControlLoading(true), 10);
    } else {
      hideLoadTimer = setTimeout(() => _setIsControlLoading(false), 500);
    }
  }

  //Check Can Edit
  const [canEditDoc, setCanEditDoc] = useState<boolean>(false);
  const [canEditLineApprove, setCanEditLineApprove] = useState<boolean>(false);
  const { canEditMemo } = useAdminEditCompletedMemoPermissionContext();
  const [isCheckAccess, setIsCheckAccess] = useState<boolean>(false);
  const [isSkipapm, setIsSkipapm] = useState<boolean>(false);
  //MemoPage Value
  const [memoId, setMemoId] = useState<any>();
  const [memoDetail, setMemoDetail] = useState<any>();

  const [listFormNames, setListFormNames] = useState<any>();
  const [lineApproval, setLineApproval] = useState<any[]>([]);
  const [listHistoryDetails, setListHistoryDetails] = useState<any[]>([]);
  const [listFileAttachDetails, setListFileAttachDetails] = useState<any[]>([]);
  const [fileAttact, setFileAttach] = useState<any[]>([]);
  const [listRefDocDetails, setListRefDocDetails] = useState<any[]>([]);
  const [isTextFromValue, setIsTextFromValue] = useState<boolean>(false);
  const [textFromValue, setTextFromValue] = useState<any>();
  //RefDoc Value
  const [refTempSelected, setRefTempSelected] = useState<any>([]);
  const [refAttribute, setRefAttribute] = useState<any>();
  const [searchRefDocData, setSearchRefDocData] = useState<any[]>([]);
  const [refOptions, setRefOptions] = useState<any[]>([]);
  const [dialogVisibleInRefTemplate, setDialogVisibleInRefTemplate] =
    useState(false);
  const [refLoading, setRefLoading] = useState<boolean>(false);
  const previousRefTempSelected = useRef<any>(null);
  const [canEditRefDoc, setCanEditRefDoc] = useState<boolean>(false);
  const { t } = useTranslation(["translation"]);
  const [refValue, setRefValue] = useState<any>();
  //MasterData Value
  const { masterSetting } = useMasterSetting();
  const [masterLeaveSpec, setMasterLeaveSpec] = useState<any>([]);
  const [masterSignature, setMasterSignature] = useState<any>([]);
  const [masterATDLFT, setMasterATDLFT] = useState<any>([]);
  const [masterRowState, setMasterRowState] = useState<any>({});
  const [masterDLAttach, setMasterDLAttach] = useState<any>();
  const [masterAttachDL, setMasterAttachDL] = useState<any>();
  const [finFo, setFinFo] = useState<any>([]);
  const [masterInterface, setMasterInterface] = useState<any>([]);
  const [lRTempCode, setLRTempCode] = useState<any>();
  const [mbkOnlyU, setMbkOnlyU] = useState<any>([]);
  const [masterProjects, setMasterProjects] = useState<any>([]);
  const [masterEmployee, setMasterEmployee] = useState<any>([]);
  const [masterCompanies, setMasterCompanies] = useState<any>([]);
  const [templateListVersion, setTemplateListVersion] = useState<any>([]);
  const [selectedTemplateVersion, setSelectedTemplateVersion] = useState<any>();
  const [isTemplateVersion, setIsTemplateVersion] = useState<boolean>(false);
  const [menuButton, setMenuButton] = useState<any[]>([]);
  const [allLogic, setAllLogic] = useState<any[]>([]);
  const [jsonConditions, setJsonConditions] = useState<string>();
  const [loadingPDF, setLoadingPDF] = useState<boolean>(false);
  const [isShowPdf, setIsShowPdf] = useState(true);
  const [isShowSum, setIsShowSum] = useState<boolean>(false);
  const [permission, setPermission] = useState<any>();
  const [masterDataValidField, setMasterDataValidField] = useState<any[]>([]);
  const [messageValidField, setMessageValidField] = useState<any>();
  const [duration, setDuration] = useState<number>(0);
  const [skipapm, setSkipapm] = useState<string[]>([]);
  //autoApprove
  const [requestActionMemo, setRequestActionMemo] = useState<boolean>(false);
  const [checkRequestActionMemo, setCheckRequestActionMemo] =
    useState<boolean>(false);
  //AutoControlAttibute
  const [numFormulas, setNumFormulas] = useState<INumberFormula[]>([]);
  const [autoNumFormat, setAutoNumFormat] = useState<IAutoNumberAttibute>({
    formats: [],
    showSymbol: "-",
    digit: 0,
    rowIndex: -1,
    colIndex: -1,
  });

  const [buttonType, setButtonType] = useState<string>("");

  const [tableOptions, setTableOptions] = useState<tableSelectOption[]>([]);
  const { muduleRequest } = useAppSettingContext();

  const previousView = useRef<any>(null);
  let previousAmount = useRef<number>(0);
  // dialog employee
  const [employeeList, setEmployeeList] = useState<any>(masterEmployee);
  const [requestDetail, setRequestDetail] = useState<any>();

  const [listReturn, setTemplate_desc] = useState<any[]>([]);
  const [returnMessage, setReturnMessage] = useState<string>("");

  const [checkInterFace, setCheckInterFace] = useState(false);
  const [interfaceButton, setInterfaceButton] = useState<string>("");
  const [uid, setUid] = useState<string | null>(null);
  const [isCopyValue, setIsCopyValue] = useState<boolean>(false);

  useEffect(() => {
    const generatedUid = uuidv4();
    setUid(generatedUid);

    if (query.get("isCopy") !== undefined && query.get("isCopy") !== null) {
      setIsCopyValue(true);
    }
  }, []);

  useEffect(() => {
    if (uid) {
      const searchParams = new URLSearchParams(search);
      searchParams.delete("WFID");
      const replaceUrl = uid.replace(/-/g, "").toUpperCase();
      searchParams.set("WFID", replaceUrl);
      const finalUrl = `${pathname}?${searchParams.toString()}`;
      history.replace(finalUrl);
    }
  }, [uid, search, pathname, history]);

  useEffect(() => {
    previousView.current = selectedView;
  }, [selectedView]);

  //Hook form
  const {
    handleSubmit,
    control,
    reset,
    register,
    setValue,
    getValues,
    trigger,
    formState: { errors, dirtyFields },
  } = useForm({
    defaultValues: {
      items: memoDetail?.template_desc?.items,
    },
    shouldUnregister: false,
  });

  useEffect(() => {
    if (!_.isEmpty(errors) && buttonType != "" && !!buttonType) {
      const data = JSON.parse(JSON.stringify(errors));

      const extractMessages = (items: any) => {
        return items.items
          .filter((item: any) => item !== null) // Remove null values from items
          .flatMap((item: any) =>
            item.layout.filter((layoutItem: any) => layoutItem !== null)
          ) // Remove null values from layout
          .map(
            (layoutItem: any) =>
              (
                layoutItem.data?.value?.message ||
                layoutItem.data?.message ||
                layoutItem.message ||
                ""
              )
                .replace(/:/g, "")
                .trim() // Remove ":" and trim whitespace
          )
          .filter((message: any) => message); // Filter out undefined messages
      };

      const filteredMsgError = extractMessages(data);

      toggleAlert({
        message: `Required Attachment.`,
        description: `${filteredMsgError} is required.`,
        type: "warning",
      });
    }
  }, [JSON.stringify(errors)]);

  const [listInToAndPass, setListInToAndPass] = useState<any>({
    to: [],
    pass: [],
  });
  const [project, setProject] = useState<any>();
  const [isBranchFromADTitle, setIsBranchFromADTitle] =
    useState<boolean>(false);
  const [isADTitleToPosition, setIsADTitleToPosition] =
    useState<boolean>(false);
  const [leaveTypeTable, setLeaveTypeTable] = useState<any>([]);
  const [isRequireAttachment, setIsRequireAttachment] =
    useState<boolean>(false);
  const [tableSummaries, setTableSummaries] = useState<any[]>();
  //RequestorValue
  const [requestor, setRequestor] = useState<any>({});
  const [creator, setCreator] = useState<any>({});
  const [edFont, setEdFont] = useState<any>([]);
  useEffect(() => {
    setLoad(false);
    const fetchMasterData = async () => {
      setLoad(true);
      const masterData = await GetMasterDataByTypeNames([
        "Signature",
        "ValidField",
        "DLAttach",
        "Interface",
        "FINFO",
        "ATDLFT",
        "LRTempCode",
        "MBKOnly",
        "LeaveSpec",
        "EdFont",
        "skipapm",
        "ComConfig",
        "AttachDL"
      ]);
      const projects = await GetAllProject();
      // const employee = await GetAllEmployee();
      const companies = await dataCompany();
      const isMultiAssign = await CanAssignMoreThanOne();
      const isMultiRequestComment = await CanRequestCommentMoreThanOne();
      sessionStorage.setItem("isMultiAssign", isMultiAssign.result);
      sessionStorage.setItem(
        "isMultiRequestComment",
        isMultiRequestComment.result
      );
      setMasterRowState(
        masterData.find((e: any) => e?.MasterType?.toLowerCase() === "rowstate")
      );
       setMasterAttachDL(
        masterData.filter((e: any) => {
          return e.MasterType === "AttachDL" && e.IsActive === true;
        })
      );
      setMasterSignature([
        ...masterData
          .filter((e: any) => {
            return e.MasterType === "Signature" && e.IsActive === true;
          })
          .sort((a: any, b: any) => (Number(a.Seq) > Number(b.Seq) ? 1 : -1)),
      ]);
      setMasterDataValidField([
        ...masterData.filter((e: any) => {
          return e.MasterType === "ValidField" && e.IsActive === true;
        }),
      ]);
      setMasterDLAttach(
        masterData.filter((e: any) => {
          return e.MasterType === "DLAttach" && e.IsActive === true;
        })[0]
      );
      setMasterInterface(
        masterData.filter((e: any) => {
          return e.MasterType === "Interface" && e.IsActive === true;
        })[0]
      );
      setFinFo(
        masterData.filter((e: any) => {
          return e.MasterType === "FINFO" && e.IsActive === true;
        })[0]
      );
      setMasterATDLFT(
        masterData.filter((e: any) => {
          return e.MasterType === "ATDLFT" && e.IsActive === true;
        })[0]
      );
      setLRTempCode(
        masterData.filter((e: any) => {
          return e.MasterType === "LRTempCode";
        })
      );
      setMbkOnlyU(
        masterData.filter((e: any) => {
          return e.MasterType === "MBKOnly" && e.IsActive === true;
        })
      );
      setMasterLeaveSpec(
        masterData.filter((e: any) => {
          return e.MasterType === "LeaveSpec" && e.IsActive === true;
        })
      );
      setEdFont(
        masterData.filter((e: any) => {
          return e.MasterType === "EdFont" && e.IsActive === true;
        })[0]
      );

      const temCodes: string[] =
        masterData
          .find(
            (e: any) => e.MasterType?.toLowerCase() === "skipapm" && e.IsActive
          )
          ?.Value1?.split("|") || [];

      setSkipapm([...temCodes]);
      setMasterProjects([...projects]);
      setMasterCompanies([...companies]);
      setCheckUseEffect(true);
    };
    fetchMasterData();
  }, []);
  const [defaultFont, setDefault] = useState<string>();
  const [rishFont, setrishFont] = useState<string>();
  useEffect(() => {
    if (edFont) {
      const fontFormat = edFont.Value1;
      const fontSize = edFont.Value2;
      setDefault(
        "@import url('../../../../ClientApp/public/font/font.css');body {font-family: '" +
        fontFormat +
        "', sans-serif; font-size : " +
        fontSize +
        ";}"
      );
      setrishFont(fontFormat);
    }
  }, [edFont]);
  useEffect(() => {
    detectLineApproval();
  }, [lineApproval]);

  useEffect(() => {
    //Check RefTemplate if have show

    if (listFormNames) {
      if (
        listFormNames.RefTemplate === "" ||
        listFormNames.RefTemplate === "[]"
      ) {
        if (isFirstRun.current) {
          isFirstRun.current = false;
        }
        setRefAttribute([]);
      } else {
        getAllRefDoc(listFormNames).then(() => {
          if (isFirstRun.current) {
            isFirstRun.current = false;
          }
        });
      }
    }
  }, [listFormNames]);

  const updateIsDirtyOfTable = (list: any) => {
    let dirtyList = { ...isDirtyOfTable }; // Clone the existing state

    // Ensure the nested structure exists before assignment
    if (!dirtyList[list.label]) {
      dirtyList[list.label] = {};
    }
    if (!dirtyList[list.label][list.rowIndex]) {
      dirtyList[list.label][list.rowIndex] = {};
    }

    dirtyList[list.label][list.rowIndex][list.colIndex] = true;
    console.log(dirtyList);

    setIsDirtyOfTable({ ...dirtyList });
  };

  const getAllRefDoc = async (listFormNames: any) => {
    if (!listFormNames?.RefDocDisplay) {
      return;
    }
    setRefLoading(true);
    let _RefID: string = "";
    if (query.get("RefID") !== undefined && query.get("RefID") !== null) {
      _RefID = query.get("RefID") || "";
    }
    const display = listFormNames?.RefDocDisplay?.split(",");

    if (!refAttribute && display.length > 0) {
      let refObject: any = {
        option: [],
        position: display[0],
        mode: display[1],
        optionLabel:
          display[2] !== "Information DocumentNo" ? display[2] : "DocumentNo",
        isDefaultLineApprove: display[4],
        optionValue: refValue,
        refIdOnQuery: null,
      };
      setRefAttribute({ ...refObject });
    }
    const res = await GetRefDocTemp({ template_ID: listFormNames.TemplateId, memoid: 0 });

    // memoDetail?.memoid ?? 0

    if (res) {
      checkRefTemplate(listFormNames, listRefDocDetails, res, _RefID);
    }
    setRefLoading(false);
  };

  const detectLineApproval = () => {
    if (lineApproval) {
      lineApproval.map((line: IListApprovalDetailsModel) => {
        if (line.signature_id && line.signature_id !== 0) {
          let _signature = masterSignature.find(
            (sig: any) => sig.MasterId === line.signature_id
          );
          if (_signature) {
            line.signature_en = _signature.Value2;
            line.signature_th = _signature.Value1;
          }
        } else {
          let _signature = masterSignature.find((sig: any) => sig.Seq === "1");
          if (_signature) {
            line.signature_en = _signature.Value2;
            line.signature_id = _signature.MasterId;
            line.signature_th = _signature.Value1;
          }
        }
      });
    }
  };

  useEffect(() => {
    if (checkUseEffect) {
      checkQuery();
    }
  }, [checkUseEffect, query]);
  useEffect(() => {
    if (checkRequestActionMemo) {
      autoApprove();
    }
  }, [requestActionMemo]);

  function autoApprove() {
    var request: IRequestOnSubmit = {
      buttonType: "approve",
      inputComment: "",
      waitingFor: "",
      waitingForId: 0,
    };
    onSubmit(memoDetail.template_desc, request);
  }
  const checkQuery = async () => {
    setLoad(true);
    let canAccess = true;
    let _templateId: number = 0;
    let _memoId: number = 0;
    let _usrId: number = 0;
    let _docTypeCode: string | null = "";
    let _isCopy: boolean = false;
    let _isPreview: boolean = false;
    let _documentNo: string = "";
    let _RefID: string = "";

    if (query.get("DocTypeCode") && !query.get("template")) {
      const _response = await GetTemplateByDocTypeCode({
        DocumentCode: query.get("DocTypeCode"),
      });
      _docTypeCode = query.get("DocTypeCode");
      _templateId = _response.TemplateId;
    }

    if (query.get("template") && !query.get("DocTypeCode")) {
      _templateId = Number(query.get("template"));
    }
    if (query.get("MemoID") && !query.get("DocumentNo")) {
      setMemoId(Number(query.get("MemoID")));
      _memoId = Number(query.get("MemoID"));

      canAccess = await onCheckPermission(_memoId);
      if (
        query.get("checkRequestActionMemo") !== null &&
        query.get("checkRequestActionMemo") !== undefined
      ) {
        setCheckRequestActionMemo(true);
      }
    }
    if (!query.get("MemoID") && query.get("DocumentNo")) {
      _documentNo = query.get("DocumentNo") || "";
    }
    if (query.get("userId")) {
      _usrId = Number(query.get("userId"));
    }
    if (query.get("isCopy") !== undefined && query.get("isCopy") !== null) {
      _isCopy = true;
    }
    if (query.get("preview") !== undefined && query.get("preview") !== null) {
      _isPreview = true;
    }
    if (query.get("RefID") !== undefined && query.get("RefID") !== null) {
      _RefID = query.get("RefID") || "";
    }
    console.log('checkQuery');
    console.log('query',query);
    
    if (
      query.get("AutoNumber") !== undefined &&
      query.get("AutoNumber") !== null &&
      query.get("RefDocLabel") !== undefined &&
      query.get("RefDocLabel") !== null &&
      query.get("ReportRef") !== undefined &&
      query.get("ReportRef") !== null
    ) {
      const _requestMemo = {
        report_ref: query.get("ReportRef"),
        auto_number: query.get("AutoNumber"),
        label_auto_number: query.get("RefDocLabel"),
      };
      console.log('_requestMemo',_requestMemo);
      
      let _tempMemoId = await GetMemoByAutoNumber(_requestMemo);
      setMemoId(Number(_tempMemoId));
      _memoId = Number(_tempMemoId);
    }

    if (canAccess) {
      await getInitialData(
        _memoId,
        _templateId,
        _docTypeCode,
        _isCopy,
        _isPreview,
        _usrId,
        _documentNo,
        _RefID
      );
    } else {
      history.push("/UnAuthorize");
      setLoad(false);
    }
  };
  const onCheckPermission = async (memoid: number) => {
    const request = {
      MemoId: memoid,
      RequesterId: userData.EmployeeId,
      RNameEn: userData.Email,
    };
    const response = await GetMemoAuthorized(request);
    if (response === false) {
      return false;
    } else {
      return true;
    }
  };

  interface rqBody {
    Memoid: number;
    TemplateId: number;
    DocumentCode: string | null;
    SecretId: string;
    DocumentNo: string;
    EmployeeId: any;
    actor: any;
  }
  const getInitialData = async (
    _memoId: number,
    _templateId: number,
    _docTypeCode: string | null,
    _isCopy: boolean,
    _isPreview: boolean,
    _usrId: number,
    _documentNo: string,
    _RefID: string
    // _templateVersionCode: string | null,
    // _versionTemplate: string | null
  ) => {
    try {
      let userDataByQuery = null;
      setRefTempSelected([]);
      setListInToAndPass({
        to: [],
        pass: [],
      });
      let hasQueryUserId: boolean = false;
      if (_usrId !== 0) {
        const _employee = await GetAllEmployee();

        userDataByQuery = _employee.find(
          (_emp: any) => _emp.EmployeeId === _usrId
        );
        if (userDataByQuery) {
          hasQueryUserId = true;
        }
      }

      const requestBody = {
        Memoid: _memoId,
        TemplateId: _templateId,
        DocumentCode: _docTypeCode,
        SecretId: "",
        DocumentNo: _documentNo,
        EmployeeId: userDataByQuery
          ? userDataByQuery.EmployeeId.toString()
          : userData.EmployeeId.toString(),
        actor: userDataByQuery ? userDataByQuery : userData,
      };
      let requestDetail: any = await GetMemoDetail(requestBody); // beam
      const reqListForm = requestDetail?.requestDetails?.listFormNames[0];
      let _isTextForm: boolean = false;

      if (_memoId !== 0) {
        _isTextForm = requestDetail?.requestDetails?.memoDetail?.is_text_form ?? false;
      } else {
        _isTextForm =
          requestDetail?.requestDetails?.listFormNames?.[0]?.IsTextForm ?? false;
      }

      let requestConditions = null;
      if (!_isTextForm) {
        try {
          requestConditions = JSON.parse(
            requestDetail?.requestDetails?.listFormNames[0].AdvanceForm
          ).ReqConditions;
        } catch (e) {
          console.error(e);
        }
      }
      let logic = await LoadLogic(
        requestDetail?.requestDetails.memoDetail.template_id !== 0
          ? requestDetail?.requestDetails.memoDetail.template_id
          : _templateId
      );
      const canViewAndPrint =
        requestDetail?.requestDetails?.memoDetail?.Permission;
      if (canViewAndPrint?.View === "F") {
        history.push("/UnAuthorize");
      }
      if (canViewAndPrint?.Print === "F") {
        setIsShowPdf(false);
      }
      setPermission(canViewAndPrint);
      let memoButtons: any[] = [];
      if (
        _memoId !== 0 ||
        (_documentNo !== null &&
          _documentNo !== "" &&
          muduleRequest.requestable)
      ) {
        let memoButton: IMemoButtonModel = {
          actor: {
            EmployeeId: userData.EmployeeId,
          },
          memoid: _memoId,
        };
        memoButtons = await GetButtonMemoByMemoId(memoButton);

        const menuButtonSort = memoButtons.sort(
          (x: any, y: any) => x.sequence - y.sequence
        );
        setMenuButton(menuButtonSort);
        setCheckActionPage("edit");
        if (_isTextForm) {
          setTextFromValue(
            requestDetail.requestDetails.memoDetail.template_desc
          );
          setIsTextFromValue(true);
          getLineApproveAtFirsts(
            requestDetail?.requestDetails?.memoDetail,
            _isCopy,
            requestConditions,
            logic
          );
        } else {
          requestDetail = {
            ...requestDetail,
            requestDetails: {
              ...requestDetail?.requestDetails,
              memoDetail: {
                ...requestDetail?.requestDetails?.memoDetail,
                template_desc: requestDetail?.requestDetails?.memoDetail
                  .template_desc
                  ? {
                    items: JSON.parse(
                      requestDetail?.requestDetails?.memoDetail?.template_desc
                    ).items.map((item: any) => {
                      return {
                        ...item,
                        layout: item.layout.map((_layout: any) => {
                          if (_layout.template.type === "tb") {
                            _layout?.template?.attribute?.column?.forEach(
                              (col: any) => {
                                if (col.label !== "rowstate") {
                                  col.isReadOnly = false;
                                  col.isShow = true;
                                }
                              }
                            );
                            _layout.isShow = true;
                            _layout.isReadOnly = false;
                          } else {
                            _layout.isShow = true;
                            _layout.isReadOnly = false;
                          }

                          return _layout;
                        }),
                      };
                    }),
                  }
                  : {},
              },
            },
          };

          const templateDescWithInterface = await prepareInitialLogicInterface(
            logic,
            requestDetail.requestDetails.memoDetail.template_desc,
            requestDetail.requestDetails.memoDetail.status
          );
          detechFormulas(
            requestDetail.requestDetails.memoDetail.template_id,
            templateDescWithInterface
          );
          let templateDescWithLogic =
            requestDetail.requestDetails.memoDetail.template_desc;
          // if (requestDetail.requestDetails.memoDetail.status === "Draft") {

          templateDescWithLogic = await prepareInitialLogic(
            logic,
            templateDescWithInterface,
            requestDetail.requestDetails.memoDetail,
            requestDetail.requestDetails.memoDetail.status,
            requestDetail.requestDetails.memoDetail.requestor,
            undefined,
            requestDetail.requestDetails.listApprovalDetails
          );
          // }


          const _template = await detechRevisionControl(
            _templateId,
            templateDescWithLogic
          );
          const autoNum = detechAutonumberFormula(_template);
          if (_template.items) {
            let _templateDesc = await initialActionFiedFormLineApprove(
              [...requestDetail.requestDetails.listApprovalDetails],
              _template.items,
              requestDetail.requestDetails.memoDetail,
              requestConditions,
              _isCopy,
              reqListForm
            );
            if (_templateDesc) {
              setDefaultTemplateDesc(_templateDesc);
              getLineApproveAtFirsts(
                requestDetail.requestDetails.memoDetail,
                _isCopy,
                requestConditions,
                logic,
                _templateDesc
              );
            }
          }
          if (_isCopy) {
            if (autoNum.rowIndex !== -1) {
              const _control = await genAutoNum(
                _template.items,
                autoNum,
                requestDetail.requestDetails.memoDetail.template_id,
                requestDetail.requestDetails.memoDetail.status,
                _isCopy
              );
              if (_control) {
                setDefaultTemplateDesc(_control);
                let _templateDesc = await initialActionFiedFormLineApprove(
                  [...requestDetail.requestDetails.listApprovalDetails],
                  _control,
                  requestDetail.requestDetails.memoDetail,
                  requestConditions,
                  _isCopy,
                  reqListForm
                );
                if (_templateDesc) {
                  setDefaultTemplateDesc(_templateDesc);
                }
                // reset({
                //   items: _control,
                // });
              }
            } else {
              setDefaultTemplateDesc(_template.items);
              let _templateDesc = await initialActionFiedFormLineApprove(
                [...requestDetail.requestDetails.listApprovalDetails],
                _template.items,
                requestDetail.requestDetails.memoDetail,
                requestConditions,
                _isCopy,
                reqListForm
              );
              if (_templateDesc) {
                setDefaultTemplateDesc(_templateDesc);
                getLineApproveAtFirsts(
                  requestDetail.requestDetails.memoDetail,
                  _isCopy,
                  requestConditions,
                  logic,
                  _templateDesc
                );
              }
            }
          }

          setIsTextFromValue(false);
        }
        if (_isCopy) {
          const mewLine =
            requestDetail?.requestDetails?.listApprovalDetails?.map(
              (e: any) => {
                e.lineid = 0;
                return e;
              }
            );
          requestDetail = {
            ...requestDetail,
            requestDetails: {
              ...requestDetail?.requestDetails,
              memoDetail: {
                ...requestDetail?.requestDetails?.memoDetail,
                memoid: 0,
                status: "New Request",
                document_no: "Auto Generate",
                copyInformation: "Y",
                creator: userData,
                requestor: userData,
                current_approval_level: 0,
                request_date: moment(new Date()).format("DD/MM/YYYY HH:mm:ss"),
                modified_date: moment(new Date()).format("DD/MM/YYYY HH:mm:ss"),
                created_date: moment(new Date()).format("DD/MM/YYYY HH:mm:ss"),
                modified_by: userData.EmployeeId.toString(),
                created_by: userData.EmployeeId.toString(),
              },
              listApprovalDetails: mewLine,
              listHistoryDetails: [],
            },
          };

          setCheckActionPage("add");
        }
      }
      //add
      else if (_memoId === 0) {
        dataGetInformationMethodMemoProp(
          requestDetail.requestDetails.listFormNames[0],
          requestDetail.requestDetails.memoDetail
        );
        setCheckActionPage("add");

        if (_isTextForm) {
          setTextFromValue(
            requestDetail.requestDetails.listFormNames[0].TextForm
          );
          setIsTextFromValue(true);
          getLineApproveAtFirsts(
            requestDetail.requestDetails?.memoDetail,
            _isCopy,
            requestConditions,
            logic
          );
        } else {
          requestDetail = {
            ...requestDetail,
            requestDetails: {
              ...requestDetail?.requestDetails,
              memoDetail: {
                ...requestDetail?.requestDetails?.memoDetail,
                template_desc: requestDetail?.requestDetails?.listFormNames[0]?.AdvanceForm
                  ? {
                    items: JSON.parse(
                      requestDetail?.requestDetails?.listFormNames[0]
                        .AdvanceForm
                    ).items.map((item: any) => {
                      return {
                        ...item,
                        layout: item.layout.map((_layout: any) => {
                          return {
                            ..._layout,
                            isShow: true,
                          };
                        }),
                      };
                    }),
                  }
                  : {},
              },
            },
          };
          const templateDescWithInterface = await prepareInitialLogicInterface(
            logic,
            requestDetail.requestDetails.memoDetail.template_desc,
            requestDetail.requestDetails.memoDetail.status
          );
          const ComConfig = masterSetting["ComConfig"];
          if (ComConfig && ComConfig?.Value1 === "blank") {
            requestDetail.requestDetails.memoDetail.company_id = 0;
            requestDetail.requestDetails.memoDetail.company_name = "";
          } else {
            console.log(
              "requestDetail.requestDetails.memoDetail.requestor",
              requestDetail.requestDetails.memoDetail.requestor
            );

            requestDetail.requestDetails.memoDetail.company_id =
              requestDetail.requestDetails.memoDetail.requestor.CompanyId;
          }

          setMasterTemplateDesc(
            requestDetail.requestDetails.listFormNames[0]?.AdvanceForm
              ? {
                items: JSON.parse(
                  requestDetail.requestDetails.listFormNames[0].AdvanceForm
                ).items.map((item: any) => {
                  return {
                    ...item,
                    layout: item.layout.map((_layout: any) => {
                      return {
                        ..._layout,
                        isShow: true,
                      };
                    }),
                  };
                }),
              }
              : {}
          );
          detechFormulas(
            requestDetail.requestDetails.memoDetail.template_id,
            templateDescWithInterface
          );

          const templateDescWithLogic = await prepareInitialLogic(
            logic,
            templateDescWithInterface,
            requestDetail.requestDetails.memoDetail,
            requestDetail.requestDetails.memoDetail.status,
            requestDetail.requestDetails.memoDetail.requestor,
            undefined,
            requestDetail.requestDetails.listApprovalDetails
          );

          const _template = await detechRevisionControl(
            _templateId,
            templateDescWithLogic
          );
          const autoNum = detechAutonumberFormula(_template);

          if (
            requestDetail.requestDetails.memoDetail.status === "New Request" ||
            _isCopy
          ) {
            if (autoNum.rowIndex !== -1) {
              const _control = await genAutoNum(
                _template.items,
                autoNum,
                requestDetail.requestDetails.memoDetail.template_id,
                requestDetail.requestDetails.memoDetail.status
              );
              if (_control) {
                setDefaultTemplateDesc(_control);
                let _templateDesc = await initialActionFiedFormLineApprove(
                  [...requestDetail.requestDetails.listApprovalDetails],
                  _control,
                  requestDetail.requestDetails.memoDetail,
                  requestConditions,
                  _isCopy,
                  reqListForm
                );
                if (_templateDesc) {
                  setDefaultTemplateDesc(_templateDesc);
                  getLineApproveAtFirsts(
                    requestDetail.requestDetails.memoDetail,
                    _isCopy,
                    requestConditions,
                    logic,
                    _templateDesc
                  );
                }
              }
            } else {
              setDefaultTemplateDesc(_template.items);
              let _templateDesc = await initialActionFiedFormLineApprove(
                [...requestDetail.requestDetails.listApprovalDetails],
                _template.items,
                requestDetail.requestDetails.memoDetail,
                requestConditions,
                _isCopy,
                reqListForm
              );
              if (_templateDesc) {
                setDefaultTemplateDesc(_templateDesc);
                getLineApproveAtFirsts(
                  requestDetail.requestDetails.memoDetail,
                  _isCopy,
                  requestConditions,
                  logic,
                  _templateDesc
                );
              }
            }
          }
          setIsTextFromValue(false);
        }
      }
      if (_isPreview) {
        setCheckActionPage("preview");
      }
      if (hasQueryUserId) {
        requestDetail.requestDetails.memoDetail.creator = userDataByQuery;
        requestDetail.requestDetails.memoDetail.requestor = userDataByQuery;
      }
      checkTemplateVersion(
        requestDetail.requestDetails.listFormNames?.[0],
        requestDetail.requestDetails.memoDetail
      );

      checkState(
        requestDetail.requestDetails.memoDetail.status,
        requestDetail.requestDetails.listFormNames?.[0],
        requestDetail.requestDetails.memoDetail.current_approval_level,
        requestDetail.requestDetails.listApprovalDetails,
        memoButtons,
        requestDetail.requestDetails.memoDetail.waiting_for_id
      );

      checkLeaveRequestTemplate(
        requestDetail.requestDetails.memoDetail.template_code
      );
      checkDataAndSetFunction(requestDetail.requestDetails.memoDetail);
      replaceTitleInfo(requestDetail.requestDetails.memoDetail);

      setCreator(requestDetail.requestDetails.memoDetail.creator);
      setRequestor(requestDetail.requestDetails.memoDetail.requestor);
      setMemoDetail(requestDetail.requestDetails.memoDetail);

      setLineApproval([...requestDetail.requestDetails.listApprovalDetails]);

      setIsRequireAttachment(
        requestDetail.requestDetails.listFormNames[0]?.RequiredAttachment
      );
      setListHistoryDetails([
        ...requestDetail.requestDetails.listHistoryDetails,
      ]);
      setListFileAttachDetails([
        ...requestDetail.requestDetails.listFileAttachDetails,
      ]);
      setFileAttach([...requestDetail.requestDetails.listFileAttachDetails]);

      previousAmount.current = Number(
        requestDetail.requestDetails.memoDetail.amount.replaceAll(",", "")
      );

      setListRefDocDetails([...requestDetail.requestDetails.listRefDocDetails]);
      setListFormNames(requestDetail.requestDetails.listFormNames[0]);

      createTableSums(requestDetail.requestDetails.memoDetail.template_desc);
      // setRefTempSelected([]);
      setRequestDetail(requestDetail);
      setAllLogic([...logic]);
      // setSelectedView("2");
      // setCurPage("2");
      setLoad(false);
    } catch (error) {
      setLoad(false);
      toggleAlert({
        message: `Error Request`,
        description: `Error: ${error}`,
        type: "error",
        duration: 15,
      });
      console.error("Request=>error", error);
    }
    setRequestActionMemo(true);
  };

  const setDefaultTemplateDesc = (template: any) => {
    let templateItems = template;
    if (templateItems) {
      for (let i = 0; i < templateItems.length; i++) {
        const item = templateItems[i];
        for (let j = 0; j < item.layout.length; j++) {
          const layout = item.layout[j];
          const templateType = layout.template.type;

          if (isCopyValue) {
            if (
              templateType === "t" ||
              templateType === "ta" ||
              templateType === "c" ||
              templateType === "dd" ||
              templateType === "r" ||
              templateType === "rvs" ||
              templateType === "im" ||
              templateType === "at" ||
              templateType === "ed" ||
              templateType === "d"
            ) {
              if (
                templateItems[i].layout[j].template?.attribute?.isNotCopy ===
                "Y"
              ) {
                templateItems[i].layout[j].data.value = null;
              }
            } else if (templateType === "tb") {
              if (templateItems[i].layout[j].template?.isNotCopy === "Y") {
                templateItems[i].layout[j].data.row = null;
              }
              let column = templateItems[i].layout[j].template.attribute.column;
              let row = templateItems[i].layout[j].data.row;
              if (row) {
                for (let b = 0; b < column.length; b++) {
                  let itemList = column[b];
                  if (itemList.control.template.attribute.isNotCopy === "Y") {
                    for (let r = 0; r < row.length; r++) {
                      let rowList = row[r];
                      for (let rl = 0; rl < rowList.length; rl++) {
                        rowList[rl].value = "";
                      }
                    }
                  }
                }
              }
            } else if (templateType === "cb") {
              if (
                templateItems[i].layout[j].template?.attribute?.isNotCopy ===
                "Y"
              ) {
                templateItems[i].layout[j].data = null;
              }
            } else {
              if (
                templateItems[i].layout[j].template?.attribute?.isNotCopy ===
                "Y"
              ) {
                templateItems[i].layout[j].data.value = null;
              }
            }
          } else {
            if (!layout?.data?.value || layout?.data?.value === "") {
              if (
                templateType === "t" ||
                templateType === "ta" ||
                templateType === "c"
              ) {
                templateItems[i].layout[j].data.value = getDefValueInTemplate(
                  layout.template
                );
              } else if (templateType === "dd" || templateType === "r") {
                templateItems[i].layout[j].data.value = getDefValueInTemplate(
                  layout.template
                );

                // DefaultCalendar
              } else if (templateType === "cb") {
                const defValue = getDefValueInTemplate(layout.template);
                console.log({ layout, defValue });
              } else if (templateType === "d") {
                if (layout.template.attribute.default !== "") {
                  layout.data.value = getDefValueInTemplate(layout.template);
                }
              }
            }
          }

          if (masterRowState?.IsActive) {
            if (templateType === "tb") {
              if (memoId !== 0) {
                if (
                  !templateItems[i].layout[j].template.attribute.column.find(
                    (e: any) => e.label === "rowstate"
                  )
                ) {
                  let tableCol: any[] =
                    templateItems[i].layout[j].template.attribute.column;
                  const rowStateCOl = {
                    guid: "dzxlp2gpxoo99w1yo3m5yt",
                    label: "rowstate",
                    alter: "",
                    control: {
                      template: {
                        type: "t",
                        label: "rowstate",
                        alter: "",
                        attribute: {
                          description: "",
                          default: memoId !== 0 ? "i" : "",
                          length: "0",
                          require: "N",
                          readonly: "N",
                          widthInTable: "0",
                          hideInPdf: "Y",
                        },
                      },
                      data: {
                        value: null,
                      },
                    },
                    isShow: false,
                  };

                  tableCol.push(rowStateCOl);
                }
              }
            }
          } else {
            if (templateType === "tb") {
              templateItems[i].layout[j].template.attribute.column =
                templateItems[i].layout[j].template.attribute.column.filter(
                  (e: any) => e.label !== "rowstate"
                );
            }
          }
          if (masterRowState?.IsActive) {
            if (templateType === "tb") {
              if (memoId !== 0) {
                if (
                  !templateItems[i].layout[j].template.attribute.column.find(
                    (e: any) => e.label === "rowstate"
                  )
                ) {
                  let tableCol: any[] =
                    templateItems[i].layout[j].template.attribute.column;
                  const rowStateCOl = {
                    guid: "dzxlp2gpxoo99w1yo3m5yt",
                    label: "rowstate",
                    alter: "",
                    control: {
                      template: {
                        type: "t",
                        label: "rowstate",
                        alter: "",
                        attribute: {
                          description: "",
                          default: memoId !== 0 ? "i" : "",
                          length: "0",
                          require: "N",
                          readonly: "N",
                          widthInTable: "0",
                          hideInPdf: "Y",
                        },
                      },
                      data: {
                        value: null,
                      },
                    },
                    isShow: false,
                  };

                  tableCol.push(rowStateCOl);
                }
              }
            }
          } else {
            if (templateType === "tb") {
              templateItems[i].layout[j].template.attribute.column =
                templateItems[i].layout[j].template.attribute.column.filter(
                  (e: any) => e.label !== "rowstate"
                );
            }
          }
        }
      }
    }

    reset({
      items: templateItems,
    });
    return {
      items: templateItems,
    };
  };
  const getLineApproveForAmount = async (
    _amount: number,
    jsonCondition?: any,
    logicType?: string,
    template?: any,
    _requestor?: any
  ) => {
    let amount = _amount;
    if (isNaN(amount) || amount == null) {
      amount = previousAmount.current;
    }
    try {
      if (isSkipapm) {
        return;
      }

      if (!isNaN(amount)) {
        setMemoDetail((prevState: any) => ({
          ...prevState,
          amount: Number(amount).toLocaleString(undefined, {
            minimumFractionDigits: 2,
          }),
        }));
      }

      let isSummary = isShowSum && amount != previousAmount.current;

      if (listFormNames.IsTextForm && isShowSum) {
        const dataJson = {
          employee: _requestor ? _requestor : memoDetail.requestor,
          ComCode: memoDetail.company_id,
          JsonCondition: jsonCondition ? jsonCondition : jsonConditions,
          templateForm: {
            ...memoDetail,
            TemplateApproveId: 0,
            template_desc: JSON.stringify(memoDetail.template_desc),
          },
          lstTRNLineApprove: [],
          Amount: Number(amount),
        };

        const responseDataLineApprove = await onLoadDataLiveApprove(
          dataJson,
          userData?.EmployeeId
        );
        if (responseDataLineApprove) {
          setLineApproval([...responseDataLineApprove]);
        }
      } else if (logicType || isSummary) {
        if (
          (memoDetail &&
            (template?.type === "c" ||
              template?.type === "tb" ||
              ((template?.type === "t" ||
                template?.type === "dd" ||
                template?.type === "r" ||
                template?.type === "cb") &&
                logicType === "datalineapprove"))) ||
          logicType === "requestor" ||
          logicType === "reset"
        ) {
          setIsControlLoading(true);

          let doa: any;
          let loc: any;
          let spc: any;
          let dtp: any;

          const dataJson = {
            employee: _requestor ? _requestor : memoDetail.requestor,
            ComCode: memoDetail.company_id,
            JsonCondition: jsonCondition ? jsonCondition : jsonConditions,
            templateForm: {
              ...memoDetail,
              TemplateApproveId: 0,
              template_desc: JSON.stringify(memoDetail.template_desc),
            },
            lstTRNLineApprove: [],
            Amount: amount,
          };
          const dataJsonApproverType = {
            TemplateId: memoDetail.template_id,
          };

          const approverType = await onLoadLiveApproveType(
            dataJsonApproverType
          );

          if (approverType) {
            doa = approverType.find((line: any) => line.ApproveType === 21);
            loc = approverType.find((line: any) => line.ApproveType === 19);
            spc = approverType.find((line: any) => line.ApproveType === 20);
            dtp = approverType.find((line: any) => line.ApproveType === 22);
          }

          if ((isSummary && doa) || !!logicType) {
            
            if(query.get("template") && (dataJson?.templateForm?.template_id  !== Number(query.get("template")??0))) return
            
            const responseDataLineApprove = await onLoadDataLiveApprove(
              dataJson,
              userData?.EmployeeId
            );

            if (responseDataLineApprove) {
              if (doa || loc || spc || dtp || logicType === "reset") {
                if (logicType === "reset") {
                  let data: any[] = [
                    ...lineApproval.slice(0, memoDetail.current_approval_level),
                    ...responseDataLineApprove.map((e: any) => {
                      e.sequence =
                        e.sequence + memoDetail.current_approval_level;
                      return e;
                    }),
                  ];

                  setLineApproval([...data]);
                } else {
                  setLineApproval([...responseDataLineApprove]);
                }
              } else if (!(doa || loc || spc || dtp) && jsonCondition) {
                setLineApproval([...responseDataLineApprove]);
              }
            } else {
            }
          }

          setIsControlLoading(false);
        }
        if (jsonCondition) {
          setJsonConditions(jsonCondition);
        }
      }
      previousAmount.current = amount;
    } catch (error) {
      toggleAlert({
        message: `Error LineApprove`,
        description: `Error: ${error}`,
        type: "error",
        duration: 15,
      });
      console.error("LineApprove=>error", error);
    }
  };

  const getLineApproveAtFirsts = async (
    _memoDetail: any,
    _isCopy: boolean,
    RequestConditions: any,
    logices: ILogic[],
    _templateDesc?: any
  ) => {
    try {
      if (isSkipapm) {
        return;
      }

      if (_memoDetail.memoid === 0 && !_isCopy) {
        let _jsonConditions = jsonConditions;

        for (let i = 0; i < logices.length; i++) {
          try {
            const logic = logices[i];
            if (logic.logictype !== null) {
              const jsonValue: ILogicTypeDataLineApprove =
                logic.jsonvalue &&
                logic.jsonvalue.length > 0 &&
                JSON.parse(logic.jsonvalue.replace(`},\r\n],`, "}],"));
              for (const detail of _templateDesc) {
                const desc = detail.layout.find(
                  (item: any) => item.template.label === jsonValue.label
                );

                if (desc) {
                  const responseData = await onProcessLogicLineApprove(
                    logic,
                    desc,
                    desc.data.value,
                    _templateDesc
                  );

                  if (responseData) {
                    _jsonConditions = responseData;
                  }
                }
              }
            }
          } catch (error) {
            console.error(error);
          }
        }

        const dataJson = {
          employee: _memoDetail.requestor,
          ComCode: _memoDetail.company_id,
          JsonCondition: _jsonConditions,
          templateForm: {
            ..._memoDetail,
            TemplateApproveId: 0,
            template_desc: JSON.stringify(_templateDesc),
          },
          lstTRNLineApprove: [],
          Amount: 0,
        };
        const responseDataLineApprove = await onLoadDataLiveApprove(
          dataJson,
          userData?.EmployeeId
        );
        setLineApproval([...responseDataLineApprove]);
        let tempdescItem = _templateDesc;
        if (tempdescItem) {
          if (responseDataLineApprove.length > 0) {
            let _templateDesc = await initialActionFiedFormLineApprove(
              [...responseDataLineApprove],
              tempdescItem,
              _memoDetail,
              RequestConditions,
              _isCopy
            );
            if (_templateDesc) {
              setDefaultTemplateDesc(_templateDesc);
            }
          }
        }
      }
    } catch (error) {
      console.error("LineApprove=>error", error);
    }
  };

  const onLoadLiveApproveType = async (dataJson: any) => {
    const respone = await fetch("api/LineApprove/GetLineApproveType", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(dataJson),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch((err: any) => console.error({ errerrerr: err }));
    return respone;
  };
  const initialActionFiedFormLineApprove = async (
    dataLineApprove: any,
    _templateDesc: any,
    _memoDetail: any,
    ReqConditions: any,
    _isCopy: boolean,
    reqListForm?: any
  ) => {
    let _jsonValue: IApprovaReadHide[] = [];
    let currentApprovals: IReqConditions;
    const _datalineapprove = dataLineApprove;
    // template setting readonly
    const TempCurrentApprovals = _datalineapprove.find(
      (e: any) => e.sequence === _memoDetail.current_approval_level
    );
    currentApprovals = TempCurrentApprovals;

    if (
      _memoDetail.status === "Wait for Comment" &&
      _memoDetail.status === "Wait for Process" &&
      _memoDetail.current_approval_level !== 0
    ) {
      const WaitForCommentcondition = _datalineapprove.find(
        (e: any) => e.sequence == _memoDetail.current_approval_level
      );
      currentApprovals = WaitForCommentcondition;
      if (
        WaitForCommentcondition &&
        WaitForCommentcondition.ColumnJsonCondValue
      ) {
        _jsonValue = deserializeColumnJsonCondValue(
          WaitForCommentcondition.ColumnJsonCondValue
        );
      }
    }
    const isRequestor =
      _memoDetail.requestor.EmployeeId === userData.EmployeeId;
    const hasUserCondition = _datalineapprove.some((line: any) => {
      return line.approver?.EmployeeId === userData.EmployeeId;
    });

    const current_approval = _datalineapprove.find(
      (e: any) => e.sequence === _memoDetail.current_approval_level && userData.EmployeeId === e?.approver?.EmployeeId
    )
    if (
      !_isCopy &&
      _memoDetail.status !== "Completed" &&
      !isRequestor && !hasUserCondition &&
      _memoDetail.current_approval_level !== 0 &&
      (!currentApprovals ||
        currentApprovals.ColumnJsonCondValue == null ||
        currentApprovals.ColumnJsonCondValue == undefined ||
        currentApprovals.ColumnJsonCondValue == "")
    ) {
      console.log(_datalineapprove, "_datalineapprove");

      return _templateDesc;
    }

    if (_memoDetail.current_approval_level === 0) {
      // check logic version if version = 2 The ReqConditions will be not null
      if (!!ReqConditions?.Conditions?.ColumnJsonCondValue) {
        // for show/hide, read-only logic version 2
        _jsonValue = JSON.parse(
          ReqConditions.Conditions.ColumnJsonCondValue
        ).Conditions;
      } else {
        // for show/hide, read-only logic version 1
        _jsonValue = _datalineapprove
          .map((e: any) =>
            deserializeColumnJsonCondValue(e.ColumnJsonCondValue)
          )
          .reduce((pre: any[], cur: any[]) => [...pre, ...cur], [])
          .filter((e: any) => e.isRequester == "Y");
      }
    } else {
      const condition =
        _datalineapprove.find(
          (e: any) => e.sequence == _memoDetail.current_approval_level
        ) ??
        _datalineapprove.findLast((e: any) => e.emp_id == userData.EmployeeId);
      const isApproverWithNoApproveType = !!current_approval && !!!condition.ColumnJsonCondValue && _.isNull(condition?.ApproveType)
      if (
        hasUserCondition &&
        isRequestor &&
        condition &&
        condition?.ColumnJsonCondValue
      ) {
        _jsonValue = deserializeColumnJsonCondValue(
          condition.ColumnJsonCondValue
        );
      } else if (isRequestor && !hasUserCondition || isApproverWithNoApproveType) {
        const Listreq = reqListForm ?? listFormNames;
        const advance =
          Listreq?.AdvanceForm && JSON.parse(Listreq?.AdvanceForm);
        if (
          advance &&
          advance?.ReqConditions?.Conditions?.ColumnJsonCondValue
        ) {
          const advanceJsonCondValue = JSON.parse(
            advance?.ReqConditions?.Conditions?.ColumnJsonCondValue
          );
          if (!!advanceJsonCondValue.Conditions.length) {
            _jsonValue = advanceJsonCondValue.Conditions;
          } else {

            const WaitForCommentcondition = _datalineapprove.find(
              (e: any) => e.sequence == _memoDetail.current_approval_level
            );
            currentApprovals = WaitForCommentcondition;
            if (
              WaitForCommentcondition &&
              WaitForCommentcondition.ColumnJsonCondValue
            ) {
              _jsonValue = deserializeColumnJsonCondValue(
                WaitForCommentcondition.ColumnJsonCondValue
              );
            }
            // const advanceJsonCondValue = JSON.parse(
            //   "{\"Conditions\":[{\"action\":\"hide\",\"fieldaction\":[{\"label\":\"ta : ข้อเสนอแนะจากผู้จัดการทั่วไปการตลาดอะไหล่\",\"key\":\"ข้อเสนอแนะจากผู้จัดการทั่วไปการตลาดอะไหล่\",\"type\":\"ta\"},{\"label\":\"r : ความคิดเห็นจากผู้จัดการทั่วไปการตลาดอะไหล่\",\"key\":\"ความคิดเห็นจากผู้จัดการทั่วไปการตลาดอะไหล่\",\"type\":\"r\"},{\"label\":\"ta : ข้อเสนอแนะจากผู้จัดการแผนกวางแผนกลยุทธ์การตลาดอะไหล่\",\"key\":\"ข้อเสนอแนะจากผู้จัดการแผนกวางแผนกลยุทธ์การตลาดอะไหล่\",\"type\":\"ta\"},{\"label\":\"r : ความคิดเห็นจากผู้จัดการแผนกวางแผนกลยุทธ์การตลาดอะไหล่\",\"key\":\"ความคิดเห็นจากผู้จัดการแผนกวางแผนกลยุทธ์การตลาดอะไหล่\",\"type\":\"r\"},{\"label\":\"ta : ข้อเสนอแนะจากผู้จัดการฝ่ายสินเชื่อ\",\"key\":\"ข้อเสนอแนะจากผู้จัดการฝ่ายสินเชื่อ\",\"type\":\"ta\"},{\"label\":\"r : ความคิดเห็นจากผู้จัดการฝ่ายสินเชื่อ\",\"key\":\"ความคิดเห็นจากผู้จัดการฝ่ายสินเชื่อ\",\"type\":\"r\"},{\"label\":\"ta : ข้อเสนอแนะจาก Parts MKT SA-Pricing\",\"key\":\"ข้อเสนอแนะจาก Parts MKT SA-Pricing\",\"type\":\"ta\"},{\"label\":\"r : ความคิดเห็นจาก Parts MKT SA-Pricing\",\"key\":\"ความคิดเห็นจาก Parts MKT SA-Pricing\",\"type\":\"r\"},{\"label\":\"at : Cost sheet\",\"key\":\"Cost sheet\",\"type\":\"at\"},{\"label\":\"r : ความคิดเห็นจากกรรมการผู้จัดการใหญ่\",\"key\":\"ความคิดเห็นจากกรรมการผู้จัดการใหญ่\",\"type\":\"r\"},{\"label\":\"ta : ข้อเสนอแนะจากกรรมการผู้จัดการใหญ่\",\"key\":\"ข้อเสนอแนะจากกรรมการผู้จัดการใหญ่\",\"type\":\"ta\"}],\"isRequester\":\"N\"}]}"
            // );
            //todo
            // console.log(memoDetail ,memoDetail?.template_id, "memoDetail?.template_id");
            //  let requestDetail: any = await GetMemoDetail({...reqBodyMemo,TemplateId :memoDetail?.template_id ,Memoid  :0 }); // beam
            // const reqListForm = requestDetail?.requestDetails?.listFormNames[0];
            // _jsonValue = advanceJsonCondValue.Conditions;
          }
        }
      } else if (condition && condition?.ColumnJsonCondValue) {
        _jsonValue = deserializeColumnJsonCondValue(
          condition.ColumnJsonCondValue
        );
      }
    }
    _jsonValue?.forEach((jsonValue) => {
      const fieldaction = jsonValue.fieldaction.filter((e) => e.key);
      fieldaction.forEach((fieldAction) => {
        _templateDesc.map((layout: any) =>
          layout.layout.map((e: any) => {
            const findTemp = checkIsCorrect(
              fieldAction.key.split(" : ")[0],
              LogicOperatorType.Equal,
              e.template.label
            );

            if (findTemp) {
              if (e.template.type !== "tb") {
                if (jsonValue.action === "readonly") {
                  e.isReadOnly = true;
                } else if (jsonValue.action === "editable") {
                  e.isEditable = true;
                } else {
                  e.isShow = false;
                }
              } else {
                const fieldSplited = fieldAction.key.split(" : ");

                if (fieldSplited[1]) {
                  e.template.attribute.column.forEach((col: any) => {
                    const targetCol = checkIsCorrect(
                      fieldSplited[1],
                      LogicOperatorType.Equal,
                      col.label
                    );

                    if (targetCol) {
                      if (jsonValue.action === "readonly") {
                        col.isReadOnly = true;
                      } else if (jsonValue.action === "editable") {
                        col.isEditable = true;
                      } else {
                        col.isShow = false;
                      }
                    }
                  });
                } else {
                  if (jsonValue.action === "readonly") {
                    e.isReadOnly = true;
                  } else if (jsonValue.action === "editable") {
                    e.isEditable = true;
                  } else {
                    e.isShow = false;
                  }
                }
              }
            }

            return e;
          })
        );
      });
    });

    return _templateDesc;
  };

  const deserializeColumnJsonCondValue = (ColumnJsonCondValue: string) => {
    let jsonValue: any[] = [];
    if (!ColumnJsonCondValue) {
      return jsonValue;
    }
    let condValue = JSON.parse(ColumnJsonCondValue);
    if (!condValue) {
      return jsonValue;
    } else if (!condValue.Conditions && condValue.action) {
      jsonValue = [condValue];
    } else if (Array.isArray(condValue.Conditions)) {
      jsonValue = condValue.Conditions.filter((x: any) => x.action);
    }
    return jsonValue;
  };
  const detechFormulas = async (_templateId: number, templateDesc: any) => {
    let _formulas: any[] = [];
    let isSummary: boolean = false;
    for (let i = 0; i < templateDesc?.items?.length; i++) {
      const templateItems = templateDesc?.items[i];
      for (let j = 0; j < templateItems.layout.length; j++) {
        const layout = templateItems.layout[j];
        let formu: INumberFormula;
        if (layout.template.type === "c") {
          if (
            layout.template.attribute.formula !== "" &&
            layout.template.attribute.formula != null
          ) {
            formu = {
              formula: layout.template.attribute.formula,
              rowIndex: i,
              colIndex: j,
            };
            _formulas.push(formu);
          }
          if (layout.template.attribute.summary === "Y") {
            isSummary = true;
          }
        } else if (
          (layout.template.type === "d", layout.template.attribute?.formula)
        ) {
          if (layout.template.attribute?.formula?.method !== "None") {
            _formulas.push({
              formula: "",
              dateFormula: layout.template.attribute?.formula,
              rowIndex: i,
              colIndex: j,
            });
          }
        } else if (layout.template.type === "tb") {
          layout.template.attribute.column.forEach((col: any) => {
            if (col.control.template.type === "c") {
              if (col.control.template.attribute.summary === "Y") {
                isSummary = true;
              }
            }
          });
        }
      }
    }

    const dataJsonApproverType = {
      TemplateId: _templateId,
    };

    const approverType = await onLoadLiveApproveType(dataJsonApproverType);

    if (approverType) {
      const doa = approverType.find((e: any) => e.ApproveType === 21);
      if (doa) {
        isSummary = true;
      }
    }

    setIsShowSum(isSummary);
    setNumFormulas([..._formulas]);
  };

  const detechAutonumberFormula = (templateDesc: any) => {
    let _autoFormats: IAutoNumberAttibute = {
      formats: [],
      showSymbol: "-",
      digit: 0,
      rowIndex: -1,
      colIndex: -1,
    };

    try {
      templateDesc?.items?.forEach((item: any, rowIdx: number) => {
        item?.layout?.forEach((layout: any, colIdx: number) => {
          if (layout.template.type === "an") {
            if (layout.template.attribute) {
              layout.template.attribute.formats.map((formats: any) => {
                for (let i = 0; i < formats.format.length; i++) {
                  if (formats.format[i]) {
                    formats.format.map((f: any) => {
                      if (f.condition === "Split") {
                      }
                    });
                  }
                }
              });
            }
            _autoFormats.formats = layout.template.attribute.formats;
            _autoFormats.showSymbol = layout.template.alter.includes("|")
              ? ""
              : layout.template.symbol;
            _autoFormats.digit = layout.template.digit;
            _autoFormats.rowIndex = rowIdx;
            _autoFormats.colIndex = colIdx;
          }
        });
      });

      setAutoNumFormat(_autoFormats);
      return _autoFormats;
    } catch (error) {
      console.error("auto=>error", error);
      return _autoFormats;
    }
  };

  const detechRevisionControl = async (_templateId: any, templateDesc: any) => {
    try {
      let requestBody: any = {};
      let items: any[] = [];
      let rowIndex = -1;
      let colIndex = -1;

      templateDesc.items?.forEach((item: any, rowIdx: number) => {
        item.layout?.forEach((layout: any, colIdx: number) => {
          if (layout.template.type === "rvs") {
            requestBody.TemplateId = _templateId;
            requestBody.RefId = 0;
            requestBody.Digit = layout.template.attribute.digit;
            requestBody.Labelrevision = layout.template.label;
            requestBody.Alter = layout.template.alter;

            if ((layout.template.attribute.conditions || []).length > 0) {
              layout.template.attribute.conditions.map((con: any) => {
                templateDesc.items.map((item: any) => {
                  item.layout.map((layout: any) => {
                    if (con.label === layout.template.label) {
                      items.push({
                        Label: con.label,
                        value: layout.data.value,
                      });
                    }
                  });
                });
              });
            }

            requestBody.MemoId = null;
            requestBody.Itemlabel = items;
            rowIndex = rowIdx;
            colIndex = colIdx;
          }
        });
      });

      if (rowIndex !== -1 && colIndex !== -1) {
        const revision = await GetRvsRunning(requestBody);
        if (
          revision.item >
          templateDesc.items[rowIndex].layout[colIndex].data.value
        ) {
          templateDesc.items[rowIndex].layout[colIndex].data.value =
            revision.item;
        }
      }

      return templateDesc;
    } catch (error) {
      console.error("rvs=>error", error);
    }
  };

  const prepareInitialLogicInterface = async (
    logics: ILogic[],
    templateDesc: any,
    memoStatus?: string
  ) => {
    let eiei = JSON.stringify(templateDesc);

    let _templateDesc = JSON.parse(eiei);
    _templateDesc = {
      items: _templateDesc?.items?.map((item: any) => {
        return {
          ...item,
          layout: item.layout.map((_layout: any) => {
            return {
              ..._layout,
              isShow: true,
            };
          }),
        };
      }),
    };

    for (let i = 0; i < logics?.length; i++) {
      const logic = logics[i];

      if (logic.logictype === LogicType.SpecialActionService) {
        const jsonValue: ILogicTypeSpecialAction =
          logic.jsonvalue &&
          logic.jsonvalue.length > 0 &&
          JSON.parse(logic.jsonvalue);
        const insert = (arr: any[], index: any, newItem: any) => [
          ...arr.slice(0, index),
          newItem,
          ...arr.slice(index),
        ];
        if (memoStatus === "New Request") {
          if (jsonValue.fieldaction) {
            for (let i = 0; i < jsonValue.fieldaction.length; i++) {
              let _fieldaction = jsonValue.fieldaction[i];
              setInterfaceButton(_fieldaction.lable);

              for (let i = 0; i < _templateDesc.items.length; i++) {
                const templateItems = _templateDesc.items[i];
                for (let j = 0; j < templateItems.layout.length; j++) {
                  const _layout = templateItems.layout[j];
                  if (_layout.template.label === _fieldaction.position) {
                    const _guid = generateQuickGuid();
                    _templateDesc.items = insert(_templateDesc.items, i + 1, {
                      layout: [
                        {
                          data: { value: null },
                          guid: _guid,
                          isShow: true,
                          template: {
                            alter: _fieldaction.lable,
                            label: _fieldaction.lable,
                            type: "spc",
                            attribute: null,
                            istext: true,
                            textvalue: "",
                          },
                        },
                      ],
                    });
                  }
                }
              }
            }
          }
          if (jsonValue.showaction) {
            let chkInterface = false;
            for (let j = 0; j < jsonValue.showaction.length; j++) {
              let _showaction = jsonValue.showaction[j];
              if (
                memoStatus === _showaction.status ||
                memoStatus === undefined
              ) {
                chkInterface = true;
              }
            }
            setCheckInterFace(chkInterface);
          }
        }
      }
    }
    return _templateDesc;
  };

  async function handleDatasourcerelated(
    logic: ILogic,
    _templateDesc: any,
    templateDesc: any
  ) {
    const jsonValue: any =
      logic.jsonvalue &&
      logic.jsonvalue.length > 0 &&
      JSON.parse(logic.jsonvalue);
    let dataValue;
    let actionDesCription = "";
    const conditions = jsonValue.conditions;
    let jsonRelated: any = [];

    if (conditions.length > 0) {
      conditions.forEach((e: any) => {
        if (e.label) {
          for (let i = 0; i < _templateDesc.items.length; i++) {
            const templateItems = _templateDesc.items[i];
            for (let j = 0; j < templateItems.layout.length; j++) {
              const _layout = templateItems.layout[j];

              if (_layout.template.label === e.label) {
                dataValue =
                  _layout.data.value || _layout.template.attribute?.default;
                actionDesCription =
                  _layout.template.description ||
                  _layout.template.attribute?.description;
                jsonRelated.push({
                  Key: e.label,
                  Value: dataValue,
                  logicid: logic.logicid,
                });
              }
            }
          }
        }
      });
    }

    if (jsonRelated.length > 0 && jsonRelated.every((e: any) => e.Value)) {
      const responseData = await onProcessLogicDataSourceRelated(
        jsonRelated,
        jsonValue,
        templateDesc,
        actionDesCription
      );

      if (responseData.data.length === 1) {
        let newControl = _templateDesc.items;

        for (let i = 0; i < responseData.relateGroup.length; i++) {
          const relateGroup = responseData.relateGroup[i];
          for (let j = 0; j < responseData.data.length; j++) {
            const relateData = responseData.data[j];

            if (
              newControl[relateGroup.row].layout[relateGroup.col].template
                .type === "cb"
            ) {
              let items =
                newControl[relateGroup.row].layout[relateGroup.col].template
                  .attribute.items;
              const resVals: string[] =
                relateData[relateGroup.relateValue.value].split(",");

              items = items.map((e: any) => {
                if (resVals.includes(e.item)) {
                  return "Y";
                }
                return "N";
              });
              newControl[relateGroup.row].layout[relateGroup.col].data.item =
                items;
              newControl[relateGroup.row].layout[relateGroup.col].data.value =
                relateData[relateGroup.relateValue.value];
            } else {
              newControl[relateGroup.row].layout[relateGroup.col].data.value =
                relateData[relateGroup.relateValue.value];
            }
            if (
              callGenAutoNumber(
                autoNumFormat,
                newControl[relateGroup.row].layout[relateGroup.col].template
              )
            ) {
              newControl = await genAutoNum(
                newControl,
                autoNumFormat,
                memoDetail.template_id,
                memoDetail.status
              );
            }
          }
        }
      }
    }
  }

  const prepareInitialLogic = async (
    logics: ILogic[],
    templateDesc: any,
    _memoDetail: IMemoDetailModel,
    isOnRef: boolean = false,
    requestor?: any,
    isRequestorChange?: boolean,
    _lineApproval?: any[]
  ) => {
    let dataGroup: any = [];
    let dataSourceLoadGroup: any[] = [];

    let eiei = JSON.stringify(templateDesc);

    let _templateDesc = JSON.parse(eiei);
    let table_dd_to_dd_Result: any[] = [];

    const exceptStatus_Nologic = ["Completed", "Rejected", "Cancelled"]
    if (isFirstRun.current) {
      _templateDesc = {
        items: _templateDesc?.items?.map((item: any) => {
          return {
            ...item,
            layout: item.layout.map((_layout: any) => {
              if (_layout.template.type === "tb") {
                _layout.template.attribute.column.forEach((col: any) => {
                  col.isReadOnly = false;
                  col.isShow = true;
                  col.isEditable = false;
                  if (
                    _layout.template.type === "tb" &&
                    _memoDetail?.current_approval_level !== 0
                  ) {
                    _layout.isReadOnly = false;
                    _layout.isEditable = false;
                  }
                });
                _layout.isShow =
                  _layout.template.type !== undefined &&
                  _layout.template.type !== "em";
                _layout.isReadOnly = false;
                _layout.isEditable = false;
              } else {
                _layout.isShow =
                  _layout.template.type !== undefined &&
                  _layout.template.type !== "em";
                _layout.isReadOnly = false;
                _layout.isEditable = false;
              }
              return _layout;
            }),
          };
        }),
      };
    }

    if (isFirstRun.current) {
      _templateDesc = {
        items: _templateDesc?.items?.map((item: any) => {
          return {
            ...item,
            layout: item.layout.map((_layout: any) => {
              if (_layout.template.type === "tb") {
                _layout.template.attribute.column.forEach((col: any) => {
                  col.isReadOnly = false;
                  col.isShow = true;
                });
                _layout.data.row =
                  _layout.data?.row?.map((e: any) =>
                    e.map((v: any) => {
                      v.isDirty = false;
                      return v;
                    })
                  ) || null;

                _layout.isShow = true;
                _layout.isReadOnly = false;
                _layout.isDirty = false;
              } else {
                _layout.isShow = true;
                _layout.isReadOnly = false;
                _layout.isDirty = false;
              }
              return _layout;
            }),
          };
        }),
      };
    }
    const exceptType = [LogicType.HideControl, LogicType.ReadOnlyControl];


    for (let i = 0; i < logics?.length; i++) {
      const logic = logics[i];
      if (
        (!exceptStatus_Nologic.includes(_memoDetail.status) || menuButton.length > 0||
        exceptType.includes(logic.logictype)) 
      ) {
        if (logic.logictype === "datasourceload") {
          const jsonValue: any =
            logic.jsonvalue &&
            logic.jsonvalue.length > 0 &&
            JSON.parse(logic.jsonvalue);

          for (let i = 0; i < _templateDesc.items.length; i++) {
            const templateItems = _templateDesc.items[i];
            for (let j = 0; j < templateItems.layout.length; j++) {
              const _layout = templateItems.layout[j];
              if (_layout.template.type !== "tb") {
                if (_layout.template.label === jsonValue.label) {
                  dataSourceLoadGroup.push({
                    isInTable: false,
                    col: j,
                    row: i,
                    data: logic.logicid,
                    jsonValue: logic.jsonvalue,
                  });
                }
              } else {
                for (
                  let k = 0;
                  k < _layout.template.attribute.column.length;
                  k++
                ) {
                  const column = _layout.template.attribute.column[k];
                  if (column.label === jsonValue.label) {
                    table_dd_to_dd_Result.push(logic);
                  }
                }
              }
            }
          }
        } else if (logic.logictype === "role" && isFirstRun.current) {
          let showTemplate: {
            isShow: boolean;
            pos: {
              row: number;
              col: number;
              tableCols?: number[];
              notUseCols?: number[];
            }[];
            readonly?: boolean;
            notInPos: { row: number; col: number }[];
          } = { isShow: false, pos: [], notInPos: [] };

          const jsonValue: ILogicTypeShowHide =
            logic.jsonvalue &&
            logic.jsonvalue.length > 0 &&
            JSON.parse(logic.jsonvalue);

          if (jsonValue.action !== "showpdf") {
            if (jsonValue.roleids && jsonValue.roleids.length > 0) {
              let userRole: IRolePermission[] = [];
              let roles: IRolePermission[] = await GetRolePermissionByUser();
              if (_memoDetail.status === "Wait for Process") {
                const currentApproval = _lineApproval?.find(
                  (e: any) => e.sequence == _memoDetail.current_approval_level
                ).emp_id;
                userRole = roles.filter(
                  (r) =>
                    r.IsDelete === false &&
                    r.EmployeeId === currentApproval.emp_id
                );
              } else {
                userRole = roles.filter(
                  (r) =>
                    r.IsDelete === false && r.EmployeeId === userData.EmployeeId
                );
              }

              const isShow = onCheckUserRolePermissionInLogic(
                userRole,
                jsonValue.roleids
              );

              if (jsonValue.action === "readonly") {
                showTemplate.readonly = true;
              }
              showTemplate.isShow = isShow;

              if (jsonValue.fieldaction) {
                for (let k = 0; k < jsonValue.fieldaction.length; k++) {
                  const field = jsonValue.fieldaction[k];
                  for (let i = 0; i < _templateDesc.items.length; i++) {
                    const templateItems = _templateDesc.items[i];
                    for (let j = 0; j < templateItems.layout.length; j++) {
                      const templateLayouts = templateItems.layout[j];

                      if (
                        field.lable === templateLayouts.template.label ||
                        field.isInTable === templateLayouts.template.label ||
                        field === templateLayouts.template.label
                      ) {
                        if (templateLayouts.template.type === "tb") {
                          let targetCols: number[] = [];
                          let notTargetCols: number[] = [];

                          templateLayouts.template.attribute.column.forEach(
                            (e: any, colIndex: number) => {
                              if (e.label === field.lable) {
                                targetCols?.push(colIndex);
                              } else {
                                notTargetCols.push(colIndex);
                              }
                            }
                          );
                          showTemplate.pos.push({
                            row: i,
                            col: j,
                            tableCols: targetCols,
                            notUseCols: notTargetCols,
                          });
                        } else {
                          showTemplate.pos.push({
                            row: i,
                            col: j,
                          });
                        }
                      } else {
                        showTemplate.notInPos.push({
                          row: i,
                          col: j,
                        });
                      }
                    }
                  }
                }
              }

              if (showTemplate.pos.length > 0) {
                for (let i = 0; i < showTemplate.pos.length; i++) {
                  const pos = showTemplate.pos[i];
                  if (
                    _templateDesc.items[pos.row].layout[pos.col].template.type ===
                    "tb"
                  ) {
                    _templateDesc.items[pos.row].layout[pos.col].isShow = true;
                    _templateDesc.items[pos.row].layout[
                      pos.col
                    ].template.attribute.column = _templateDesc.items[
                      pos.row
                    ].layout[pos.col].template.attribute.column.map(
                      (column: any, colIndex: number) => {
                        if (column.label !== "rowstate") {
                          if (pos.tableCols?.includes(colIndex)) {
                            if (showTemplate.readonly) {
                              column.control.template.attribute.require = "Y";
                            }

                            column.isShow =
                              jsonValue.action !== "hide" ? isShow : !isShow;
                          }
                        } else {
                          column.isShow = false;
                        }

                        return column;
                      }
                    );
                  } else {
                    if (jsonValue.action === "readonly") {
                      _templateDesc.items[pos.row].layout[pos.col].isReadOnly =
                        isShow;
                    } else {
                      _templateDesc.items[pos.row].layout[pos.col].isShow =
                        jsonValue.action !== "hide" ? isShow : !isShow;
                    }
                  }
                }
              }
            }
          }
        } else if (logic.logictype === "reference") {
          let responseData: {
            loadTo: any[];
            data: any[];
            row: number;
            col: number;
          } | null = null;
          JSON.parse(logic.jsonvalue);
          const jsonValue: ILogicTypeReference =
            logic.jsonvalue &&
            logic.jsonvalue.length > 0 &&
            JSON.parse(logic.jsonvalue);
          if (jsonValue.Filter.length > 0) {
            for (let i = 0; i < _templateDesc.items.length; i++) {
              const templateItems = _templateDesc.items[i];

              for (let j = 0; j < templateItems.layout.length; j++) {
                const _layout = templateItems.layout[j];
                responseData = await onProcessLogicReference(
                  logic,
                  _layout.template,
                  _layout.data.value,
                  _templateDesc.items
                );
                if (responseData) {
                  const permittedValues = responseData.data.map(function (
                    value: any
                  ) {
                    let res: any = {};
                    for (let i = 0; i < responseData!.loadTo.length; i++) {
                      const field = responseData!.loadTo[i];
                      res[field["TBColumn"]] = value[field["MSTColumn"]];
                    }
                    return res;
                  });
                  let resRow: any[] = [];
                  if (permittedValues) {
                    for (let i = 0; i < permittedValues.length; i++) {
                      const perValue = permittedValues[i];
                      let colData = new Array(
                        templateDesc?.items[responseData.row].layout[
                          responseData.col
                        ].template.attribute.column.length
                      ).fill({ value: "" });
                      for (const [key, value] of Object.entries(perValue)) {
                        for (
                          let j = 0;
                          j <
                          templateDesc?.items[responseData.row].layout[
                            responseData.col
                          ].template.attribute.column.length;
                          j++
                        ) {
                          const _tableCol =
                            templateDesc?.items[responseData.row].layout[
                              responseData.col
                            ].template.attribute.column[j];

                          if (_tableCol.label === key) {
                            colData[j] = { value };
                          }
                        }
                      }
                      resRow.push(colData);
                    }

                    if (
                      resRow.length > 0 &&
                      (!_templateDesc.items[responseData.row].layout[
                        responseData.col
                      ].data.row ||
                        _templateDesc.items[responseData.row].layout[
                          responseData.col
                        ].data?.row?.length === 0)
                    ) {
                      _templateDesc.items[responseData.row].layout[
                        responseData.col
                      ].data.row = [...resRow];
                    }
                  }
                }
              }
            }
          } else {
            responseData = await onProcessLogicReferenceNoFilter(
              logic,
              _templateDesc.items
            );
            if (responseData) {
              const permittedValues = responseData.data.map(function (
                value: any
              ) {
                let res: any = {};
                for (let i = 0; i < responseData!.loadTo.length; i++) {
                  const field = responseData!.loadTo[i];
                  res[field["TBColumn"]] = value[field["MSTColumn"]];
                }
                return res;
              });
              let resRow: any[] = [];
              if (permittedValues) {
                for (let i = 0; i < permittedValues.length; i++) {
                  const perValue = permittedValues[i];
                  let colData = new Array(
                    templateDesc?.items[responseData.row].layout[
                      responseData.col
                    ].template.attribute.column.length
                  ).fill({ value: "" });
                  for (const [key, value] of Object.entries(perValue)) {
                    for (
                      let j = 0;
                      j <
                      templateDesc?.items[responseData.row].layout[
                        responseData.col
                      ].template.attribute.column.length;
                      j++
                    ) {
                      const _tableCol =
                        templateDesc?.items[responseData.row].layout[
                          responseData.col
                        ].template.attribute.column[j];

                      if (_tableCol.label === key) {
                        colData[j] = { value };
                      }
                    }
                  }
                  resRow.push(colData);
                }
                if (
                  resRow.length > 0 &&
                  (!_templateDesc.items[responseData.row].layout[responseData.col]
                    .data.row ||
                    _templateDesc.items[responseData.row].layout[responseData.col]
                      .data?.row?.length === 0)
                ) {
                  _templateDesc.items[responseData.row].layout[
                    responseData.col
                  ].data.row = [...resRow];
                }
              }
            }
          }
        } else if (logic.logictype === "datareladtoloaddata") {
          const jsonValue: ILogicTypeReladToLoadData =
            logic.jsonvalue &&
            logic.jsonvalue.length > 0 &&
            JSON.parse(logic.jsonvalue.replace(`},\r\n],`, "}],"));

          for (let i = 0; i < _templateDesc.items.length; i++) {
            const templateItems = _templateDesc.items[i];
            for (let j = 0; j < templateItems.layout.length; j++) {
              const _layout = templateItems.layout[j];
              if (
                _layout.template.type !== "tb" &&
                _layout.template.label === jsonValue.autoloadvaluelabel.label
              ) {
                if (
                  _layout.data.value === null ||
                  (!isFirstRun.current && _layout.data.value === null)
                ) {
                  _layout.data.value = getDefValueInTemplate(_layout.template);
                }
              }
            }
          }
          table_dd_to_dd_Result.push(logic);
        } else if (logic.logictype === "refinfomation") {
          const jsonValue: ILogicReferenceInformation =
            logic.jsonvalue &&
            logic.jsonvalue.length > 0 &&
            JSON.parse(logic.jsonvalue);
          let hasDatalineapprove: any = null;
          let actionTemplate: any = null;

          for (let i = 0; i < _templateDesc.items.length; i++) {
            const templateItems = _templateDesc.items[i];
            for (let j = 0; j < templateItems.layout.length; j++) {
              const _layout = templateItems.layout[j];
              if (_layout.template.type !== "tb") {
                try {
                  let objMemo: any = _memoDetail;

                  if (!objMemo.company_id) {
                    objMemo.company_id = masterCompanies[0].CompanyId;
                    objMemo.company_name = masterCompanies[0].NameEn;
                  }

                  const refValue = getRefInforValue(
                    jsonValue.required,
                    objMemo,
                    userData
                  );

                  if (_layout.template.label === jsonValue.condition) {
                    if (jsonValue.required.startsWith("Company_")) {
                      const selctedCom = masterCompanies.find(
                        (e: { CompanyId: string }) => e.CompanyId == refValue
                      );

                      _layout.data.value = selctedCom.NameEn;
                    } else {
                      _layout.data.value = refValue;
                    }

                    const newLogic = checkCallLogic(
                      isFirstRun.current ? logics : allLogic,
                      _layout.template
                    );

                    if (!isFirstRun.current) {
                      hasDatalineapprove = newLogic?.find(
                        (e) => e.logictype === "datalineapprove"
                      );
                      actionTemplate = _layout;
                    }

                    let hasDatadatasourcerelated: any = null;

                    hasDatadatasourcerelated = await newLogic?.find(
                      (e) => e.logictype === "datasourcerelated"
                    );

                    if (hasDatadatasourcerelated) {
                      await handleDatasourcerelated(
                        hasDatadatasourcerelated,
                        _templateDesc,
                        templateDesc
                      );
                    }
                  }
                } catch (error) {
                  console.error(error);
                }
              } else {
                const con = jsonValue.condition.split(" | ");

                if (con[0] === _layout.template.label) {
                  table_dd_to_dd_Result.push(logic);
                }
              }
            }
          }

          if (actionTemplate) {
            if (callGenAutoNumber(autoNumFormat, actionTemplate?.template)) {
              _templateDesc.items = await genAutoNum(
                _templateDesc.items,
                autoNumFormat,
                memoDetail.template_id,
                memoDetail.status
              );
            }

            if (hasDatalineapprove) {
              const res = await onProcessLogicLineApprove(
                hasDatalineapprove,
                actionTemplate.template,
                actionTemplate.data.value,
                _templateDesc.items
              );

              if (res) {
                await getLineApproveForAmount(
                  memoDetail?._amount,
                  res,
                  LogicType.DataLineApprove,
                  actionTemplate.template
                );
                setIsControlLoading(false);
              }
            }
          }
        } else if (logic.logictype === "datasourcerelated") {
          const jsonValue: any =
            logic.jsonvalue &&
            logic.jsonvalue.length > 0 &&
            JSON.parse(logic.jsonvalue);
          let dataValue;
          let actionDesCription = "";
          const conditions = jsonValue.conditions;
          let jsonRelated: any = [];
          if (jsonValue.tablestatus) {
            table_dd_to_dd_Result.push(logic);
          } else {
            if (conditions.length > 0) {
              conditions.forEach((e: any) => {
                if (e.label) {
                  for (let i = 0; i < _templateDesc.items.length; i++) {
                    const templateItems = _templateDesc.items[i];
                    for (let j = 0; j < templateItems.layout.length; j++) {
                      const _layout = templateItems.layout[j];

                      if (_layout.template.label === e.label) {
                        dataValue =
                          _layout.data.value ||
                          _layout.template.attribute?.default;
                        actionDesCription =
                          _layout.template.description ||
                          _layout.template.attribute?.description;
                        jsonRelated.push({
                          key: e.label,
                          value: dataValue,
                          logicid: logic.logicid,
                        });
                      }
                    }
                  }
                }
              });
            }

            if (
              jsonRelated.length > 0 &&
              jsonRelated.every((e: any) => e.value)
            ) {
              const responseData = await onProcessLogicDataSourceRelated(
                jsonRelated,
                jsonValue,
                templateDesc,
                actionDesCription
              );

              if (responseData.data.length === 1) {
                let newControl = _templateDesc.items;

                for (let i = 0; i < responseData.relateGroup.length; i++) {
                  const relateGroup = responseData.relateGroup[i];
                  for (let j = 0; j < responseData.data.length; j++) {
                    const relateData = responseData.data[j];

                    if (
                      newControl[relateGroup.row].layout[relateGroup.col].template
                        .type === "cb"
                    ) {
                      let items =
                        newControl[relateGroup.row].layout[relateGroup.col]
                          .template.attribute.items;
                      const resVals: string[] =
                        relateData[relateGroup.relateValue.value].split(",");

                      items = items.map((e: any) => {
                        if (resVals.includes(e.item)) {
                          return "Y";
                        }
                        return "N";
                      });
                      newControl[relateGroup.row].layout[
                        relateGroup.col
                      ].data.item = items;
                      newControl[relateGroup.row].layout[
                        relateGroup.col
                      ].data.value = relateData[relateGroup.relateValue.value];
                    } else {
                      newControl[relateGroup.row].layout[
                        relateGroup.col
                      ].data.value = relateData[relateGroup.relateValue.value];
                    }
                    if (
                      callGenAutoNumber(
                        autoNumFormat,
                        newControl[relateGroup.row].layout[relateGroup.col]
                          .template
                      )
                    ) {
                      newControl = await genAutoNum(
                        newControl,
                        autoNumFormat,
                        memoDetail.template_id,
                        memoDetail.status
                      );
                    }
                  }
                }
              }
            }
          }
        } else if (logic.logictype === "datalineapprove") {
          const jsonValue: ILogicTypeDataLineApprove =
            logic.jsonvalue &&
            logic.jsonvalue.length > 0 &&
            JSON.parse(logic.jsonvalue.replace(`},\r\n],`, "}],"));
          for (let i = 0; i < _templateDesc.items.length; i++) {
            const templateItems = _templateDesc.items[i];
            for (let j = 0; j < templateItems.layout.length; j++) {
              if (jsonValue.label === templateItems.layout[j].template.label) {
                const responseData = await onProcessLogicLineApprove(
                  logic,
                  templateItems.layout[j].template,
                  templateItems.layout[j].data.value,
                  _templateDesc
                );
                if (responseData) {
                  setJsonConditions(responseData);
                  break;
                }
              }
            }
          }
        } else if (logic.logictype === LogicType.HideControl) {
          const jsonValue: ILogicTypeHideControl = JSON.parse(logic.jsonvalue);

          const isTable = processHideControlLogic(
            jsonValue,
            _templateDesc.items,
            {process : "isShow"},
            memoDetail,
            userData
          );

          if (isTable) {
            table_dd_to_dd_Result.push(logic);
          }
        } else if (logic.logictype === LogicType.ReadOnlyControl) {
          const jsonValue: ILogicTypeReadOnly = JSON.parse(logic.jsonvalue);

          const isTable = processHideControlLogic(
            jsonValue,
            _templateDesc.items,
            {process : "isReadOnly"},
            memoDetail,
            userData
          );
          if (isTable) {
            table_dd_to_dd_Result.push(logic);
          }
        } else if (logic.logictype === LogicType.SetValueControl) {
          const jsonValue: any =
            logic.jsonvalue &&
            logic.jsonvalue.length > 0 &&
            JSON.parse(logic.jsonvalue.replace(`},\r\n],`, "}],"));
          jsonValue.actionControl = JSON.parse(jsonValue.actionControl);
          let hasDatalineapprove: any = null;
          let actionTemplate: any = null;
          if (
            jsonValue.actionControl.isInTable &&
            jsonValue.actionControl.isInTable !== ""
          ) {
            table_dd_to_dd_Result.push(logic);
          } else {
            let valueToSet: any = null;

            jsonValue.conditions.forEach(
              (consGroup: { conditions: string | any[]; valuetoset: any }) => {
                let isConditionsSatisfied = true;

                for (let i = 0; i < consGroup?.conditions?.length; i++) {
                  const con = consGroup.conditions[i];
                  let conditionSatisfied = false;

                  for (let k = 0; k < _templateDesc.items.length; k++) {
                    for (
                      let l = 0;
                      l < _templateDesc.items[k].layout.length;
                      l++
                    ) {
                      const _layout = _templateDesc.items[k].layout[l];
                      const _label = _layout.label || _layout.template.label;

                      if (con.field === _label) {
                        const dataValue =
                          _layout.data.value ??
                          getDefValueInTemplate(_layout.template);
                        conditionSatisfied = checkIsCorrect(
                          dataValue,
                          con.operator,
                          con.value
                        );
                        if (i === 0) {
                          isConditionsSatisfied = conditionSatisfied;
                        } else {
                          isConditionsSatisfied =
                            isConditionsSatisfied && conditionSatisfied;
                        }
                      }
                    }
                  }
                }

                if (isConditionsSatisfied) {
                  valueToSet = consGroup.valuetoset;
                }
              }
            );

            _templateDesc.items?.forEach((control: { layout: any[] }) => {
              control.layout?.forEach((layout) => {
                if (layout.template.label === jsonValue.actionControl.label) {
                  layout.data.value = valueToSet;
                  if (!isFirstRun.current) {
                    const newLogic = checkCallLogic(allLogic, layout.template);
                    hasDatalineapprove = newLogic.find(
                      (e) => e.logictype === "datalineapprove"
                    );
                    actionTemplate = layout;
                  }
                } else {
                  try {
                    if (
                      layout.template.label === jsonValue.actionControl.isInTable
                    ) {
                      const colIdx = layout?.template?.attribute?.column
                        ?.map((e: any) => e.label)
                        .indexOf(jsonValue.actionControl.label);

                      layout.data.row?.map((row: any) => {
                        row[colIdx].value = valueToSet;
                      });
                    }
                  } catch (error) {
                    console.error(error);
                  }
                }
              });
            });
            if (actionTemplate) {
              if (callGenAutoNumber(autoNumFormat, actionTemplate?.template)) {
                _templateDesc.items = await genAutoNum(
                  _templateDesc.items,
                  autoNumFormat,
                  memoDetail.template_id,
                  memoDetail.status
                );
              }

              if (hasDatalineapprove) {
                const res = await onProcessLogicLineApprove(
                  hasDatalineapprove,
                  actionTemplate.template,
                  actionTemplate.data.value,
                  _templateDesc.items
                );

                if (res) {
                  await getLineApproveForAmount(
                    memoDetail?._amount,
                    res,
                    LogicType.DataLineApprove,
                    actionTemplate.template
                  );
                  setIsControlLoading(false);

                  // return { type: "lineapprove", value: responseData };
                }
              }
            }
          }
        }
      }
    }

    if (dataSourceLoadGroup.length > 0) {
      dataGroup.push({
        type: "datasourceload",
        dataGroup: dataSourceLoadGroup,
      });
    }

    const initialLogicData: any[] = await getInitialLogicData(
      dataGroup,
      _memoDetail
    );

    for (let i = 0; i < initialLogicData.length; i++) {
      const logicData = initialLogicData[i];

      const processData = formatKeyLogicData(logicData);
      const controlType =
        _templateDesc.items[processData?.row] &&
        _templateDesc.items[processData.row].layout[processData.col].template
          .type;
      if (controlType !== "spc") {
        if (
          logicData.isInTable === false ||
          logicData.isInTable === undefined
        ) {
          try {
            const defItems = _templateDesc.items[processData.row].layout[
              processData.col
            ].template?.attribute?.items
              ?.filter((e: any) =>
                _templateDesc.items[processData.row].layout[processData.col]
                  .template.type === "dd" ||
                  _templateDesc.items[processData.row].layout[processData.col]
                    .template.type === "r"
                  ? e.checked === "Y"
                  : e.check === "Y"
              )
              .map((e: { item: any }) => e.item);

            const resData = processData.data.map((e: any) => {
              if (defItems?.includes(e.item)) {
                if (controlType === "dd") {
                  e.checked = "Y";
                } else if (controlType === "cb") {
                  e.check = "Y";
                }
              }
              return e;
            });

            _templateDesc.items[processData.row].layout[
              processData.col
            ].template.attribute.items = resData;
          } catch (error) {
            console.error(error);
          }
        } else {
          _templateDesc.items[processData.row].layout[
            processData.col
          ].template.attribute.column[
            processData.tableColumn
          ].control.template.attribute.items = processData.data;
        }
      }
    }
    console.log("table_dd_to_dd_Result", table_dd_to_dd_Result);

    setTableOptions([...new Set(table_dd_to_dd_Result)]);

    return _templateDesc;
  };
  //check if control has logic
  const checkCallLogic = (logics: any, controlTemplate: any) => {
    let callLogic: any[] = [];

    logics.forEach((logic: ILogic) => {
      if (logic.logictype === LogicType.DataSourceRelated) {
        const jsonValue: ILogicTypeSourceRelated =
          logic.jsonvalue &&
          logic.jsonvalue.length > 0 &&
          JSON.parse(logic.jsonvalue.replace(`},\r\n],`, "}],"));

        if (controlTemplate.type === "tb") {
          for (let j = 0; j < controlTemplate.attribute.column.length; j++) {
            const col = controlTemplate.attribute.column[j];
            if (jsonValue.label === col.label) {
              callLogic.push(logic);
            }
          }
        } else {
          if (jsonValue.label === controlTemplate.label) {
            callLogic.push(logic);
          }
        }
      } else if (logic.logictype === LogicType.DataAjaxLoadTable) {
        const jsonValue: ILogicTypeSourceRelated =
          logic.jsonvalue &&
          logic.jsonvalue.length > 0 &&
          JSON.parse(logic.jsonvalue.replace(`},\r\n],`, "}],"));

        const selectAction = jsonValue.labelactions.find(
          (e) => e.label === controlTemplate.label
        );
        if (selectAction) {
          callLogic.push(logic);
        }
      } else if (logic.logictype === LogicType.DataRelatedToLoadData) {
        const jsonValue: ILogicTypeReladToLoadData =
          logic.jsonvalue &&
          logic.jsonvalue.length > 0 &&
          JSON.parse(logic.jsonvalue.replace(`},\r\n],`, "}],"));
        if (controlTemplate.type === "tb") {
          for (let i = 0; i < jsonValue.labelactions.length; i++) {
            const labelAction = jsonValue.labelactions[i];
            for (let j = 0; j < controlTemplate.attribute.column.length; j++) {
              const col = controlTemplate.attribute.column[j];
              if (labelAction.label === col.label) {
                callLogic.push(logic);
              }
            }
          }
        } else {
          for (let i = 0; i < jsonValue.labelactions.length; i++) {
            const labelAction = jsonValue.labelactions[i];

            if (labelAction.label === controlTemplate.label) {
              callLogic.push(logic);
            }
          }
        }
      } else if (logic.logictype === LogicType.Reference) {
        const jsonValue: ILogicTypeReference =
          logic.jsonvalue &&
          logic.jsonvalue.length > 0 &&
          JSON.parse(logic.jsonvalue.replace(`},\r\n],`, "}],"));
        for (let i = 0; i < jsonValue.Filter.length; i++) {
          const filter = jsonValue.Filter[i];
          if (filter.TBColumn === controlTemplate.label) {
            callLogic.push(logic);
          }
        }
      } else if (logic.logictype === LogicType.DataLineApprove) {
        const jsonValue: ILogicTypeDataLineApprove =
          logic.jsonvalue &&
          logic.jsonvalue.length > 0 &&
          JSON.parse(logic.jsonvalue.replace(`},\r\n],`, "}],"));
        if (jsonValue.label === controlTemplate.label) {
          callLogic.push(logic);
        }
      } else if (
        logic.logictype === LogicType.SetValueControl ||
        logic.logictype === LogicType.HideControl ||
        logic.logictype === LogicType.ReadOnlyControl
      ) {
        const jsonValue: any = JSON.parse(logic.jsonvalue);
        let allLabel: any[] = [];
        const tempColumns: string[] =
          controlTemplate?.attribute?.column?.map(
            (e: { label: any }) => e.label
          ) ?? [];
        jsonValue.conditions.map((con: any) => {
          try {
            if (typeof con.field === "string") {
              con.field = JSON.parse(con.field);
            }

            con.conditions.forEach((condition: any) => {
              allLabel.push(condition.field);
            });
          } catch (error) {
            console.error(error);
          }
        });

        if (
          allLabel.includes(controlTemplate.label) ||
          allLabel.filter((e) => tempColumns.includes(e)).length > 0
        ) {
          callLogic.push(logic);
        }
      }
    });

    return callLogic;
  };
  const onProcessLogicDataSourceRelated = async (
    jsonRelated: any,
    jsonValue: any,
    _templateDesc: any,
    actionDesCription: string
  ) => {
    let responseDataSourceLoadRelated: any = {
      relateGroup: [],
      data: [],
    };

    responseDataSourceLoadRelated.data = await onDatareladToLoadData(
      jsonRelated
    );

    if (responseDataSourceLoadRelated.data?.length > 0) {
      for (let i = 0; i < jsonValue.relatedvalue?.length; i++) {
        let relateValue = jsonValue?.relatedvalue[i];

        for (let j = 0; j < _templateDesc?.items?.length; j++) {
          const item = _templateDesc?.items[j];
          for (let k = 0; k < item.layout?.length; k++) {
            const layout = item?.layout[k];

            if (layout.template.label === relateValue.label) {
              responseDataSourceLoadRelated.relateGroup.push({
                row: j,
                col: k,
                relateValue,
              });
            }
          }
        }
      }
    }
    return responseDataSourceLoadRelated;
  };

  const onDatareladToLoadData = async (dataJson: any) => {
    const response = await fetch(
      "api/TemplateList/TemplateByid/LoadLogic/GetLoadDataFormControl2",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(dataJson),
      }
    )
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch(() => false);
    return response;
  };

  const getInitialLogicData = async (
    dataGroup: any[],
    _memoDetail: IMemoDetailModel
  ) => {
    let dataSourceLoad: any = [];
    const dataSourceLoadGroup: any[] = dataGroup.filter(
      (group: any) => group.type === "datasourceload"
    );

    if (dataSourceLoadGroup.length > 0) {
      dataSourceLoad = await onDataSourceLoad(dataSourceLoadGroup, _memoDetail);
    }
    return [...dataSourceLoad];
  };

  function onCheckUserRolePermissionInLogic(
    userRoles: IRolePermission[],
    accessRoles: {
      id: number;
    }[]
  ) {
    for (let i = 0; i < userRoles.length; i++) {
      const userRole = userRoles[i];
      for (let j = 0; j < accessRoles.length; j++) {
        const accessRole = accessRoles[j];
        if (
          userRole.RoleId === Number(accessRole.id) ||
          userRole.RoleId === Number(accessRole)
        ) {
          return true;
        }
      }
    }
    return false;
  }
  const onFilterLoadtoField = (label: string, templateDesc: any) => {
    for (let i = 0; i < templateDesc.length; i++) {
      const item = templateDesc[i];
      for (let j = 0; j < item.layout.length; j++) {
        const layout = item.layout[j];
        if (layout.template.label === label) {
          return { row: i, col: j };
        }
      }
    }
  };
  const onFilterRefFilterField = (
    refFilter: ILogicReferenceField[],
    currentFieldValue: any
  ) => {
    let _refFilter: ILogicReferenceField[] = [];

    for (let i = 0; i < currentFieldValue.length; i++) {
      const item = currentFieldValue[i];
      for (let j = 0; j < item.layout.length; j++) {
        const layout = item.layout[j];
        for (let i = 0; i < refFilter.length; i++) {
          const _ref = refFilter[i];
          if (_ref.TBColumn === layout.template.label) {
            _refFilter.push({
              MSTColumn: _ref.MSTColumn,
              TBColumn: layout.data.value,
            });
          }
        }
      }
    }
    return _refFilter;
  };
  const onLoadReferenceData = async (dataJson: {
    jsonValue: ILogicTypeReference;
    refFilter: ILogicReferenceField[];
  }) => {
    let orCondition = "";
    const refFilterValueEqualComlumAll = dataJson.refFilter.filter(
      (_ref) => _ref.MSTColumn === dataJson.jsonValue.ColumnAll
    );
    if (refFilterValueEqualComlumAll.length > 0) {
      for (let i = 0; i < refFilterValueEqualComlumAll.length; i++) {
        const ref = refFilterValueEqualComlumAll[i];
        orCondition = `(${ref.MSTColumn}='${ref.TBColumn}' OR ${dataJson.jsonValue.ColumnAll}='All')`;
      }
    }

    let condition = "";

    let refFilterValue: ILogicReferenceField[] = dataJson.refFilter.filter(
      (_ref) => _ref.MSTColumn !== dataJson.jsonValue.ColumnAll
    );

    for (let i = 0; i < refFilterValue.length; i++) {
      const ref = refFilterValue[i];
      if (i !== refFilterValue.length - 1) {
        condition = condition + ref.MSTColumn + "='" + ref.TBColumn + "' AND ";
      } else {
        condition = condition + ref.MSTColumn + "='" + ref.TBColumn + "'";
      }
    }
    if (refFilterValue.length === 0) {
      condition = "1 = 1";
    }

    const _dataJson = {
      ...dataJson.jsonValue,
      orCondition,
      condition,
    };

    const dataSource = await fetch(
      "api/TemplateList/TemplateByid/LoadLogic/GetLoadDataFormControlRef",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(_dataJson),
      }
    )
      .then((response) => response.json())
      .then((data: any) => {
        return data;
      });
    return dataSource;
  };
  const formatDate = (date: string) => {
    return moment(date).isValid() ? moment(date).format("DD-MMM-YYYY") : date;
  };
  const onProcessLogicReference = async (
    logic: ILogic,
    controlTemplate: any,
    controlValue: any,
    control: any
  ) => {
    let responseDataReference: {
      loadTo: any[];
      data: any[];
      row: number;
      col: number;
    } | null = {
      loadTo: [],
      data: [],
      row: -1,
      col: -1,
    };
    const jsonValue: ILogicTypeReference =
      logic.jsonvalue &&
      logic.jsonvalue.length > 0 &&
      JSON.parse(logic.jsonvalue);
    const loadTo = onFilterLoadtoField(jsonValue.label, control);
    const refFilter = onFilterRefFilterField(jsonValue.Filter, control);

    if (
      refFilter.length > 0 &&
      loadTo &&
      jsonValue.Filter.filter((_ref) => _ref.TBColumn === controlTemplate.label)
        .length > 0
    ) {
      const dataJson = {
        jsonValue,
        refFilter,
      };
      const refData: { DT: any[] } = await onLoadReferenceData(dataJson);
      refData.DT.forEach((item) => {
        Object.keys(item).forEach((key) => {
          const value = item[key];
          if (
            typeof value === "string" &&
            moment(value, moment.ISO_8601, true).isValid()
          ) {
            item[key] = formatDate(value);
          }
        });
      });
      console.log("refDataXXX", refData.DT);

      responseDataReference.data = refData.DT;
      responseDataReference.col = loadTo.col;
      responseDataReference.row = loadTo.row;
      responseDataReference.loadTo = jsonValue.Column;
      return responseDataReference;
    }
    return null;
  };

  const onProcessLogicReferenceNoFilter = async (
    logic: ILogic,
    control: any
  ) => {
    let responseDataReference: {
      loadTo: any[];
      data: any[];
      row: number;
      col: number;
    } | null = {
      loadTo: [],
      data: [],
      row: -1,
      col: -1,
    };
    const jsonValue: ILogicTypeReference =
      logic.jsonvalue &&
      logic.jsonvalue.length > 0 &&
      JSON.parse(logic.jsonvalue);

    const loadTo = onFilterLoadtoField(jsonValue.label, control);
    const refFil: any = jsonValue.Filter;

    if (loadTo && jsonValue.Filter.length === 0) {
      const dataJson = {
        jsonValue,
        refFilter: refFil,
      };
      const refData: { DT: any[] } = await onLoadReferenceData(dataJson);
      refData.DT.forEach((item) => {
        Object.keys(item).forEach((key) => {
          const value = item[key];
          if (
            typeof value === "string" &&
            moment(value, moment.ISO_8601, true).isValid()
          ) {
            item[key] = formatDate(value);
          }
        });
      });
      console.log("refDataXXX", refData.DT);

      responseDataReference.data = refData.DT;
      responseDataReference.col = loadTo.col;
      responseDataReference.row = loadTo.row;
      responseDataReference.loadTo = jsonValue.Column;
      return responseDataReference;
    }
    return null;
  };

  const onControlChange = async (
    controlName: any,
    controlValue: any,
    controlUpdate: any
  ) => {
    if (controlValue === "FA | Financial and Accounting") {
      const _controlString = JSON.stringify(getValues("items"));
      let _control = JSON.parse(_controlString);
      _control[1].layout[1].data.value = "100";
      controlUpdate(1, {
        ..._control[1],
        layout: [..._control[1].layout],
      });
    }
  };
  const onDataSourceLoad = async (
    dataGroup: any,
    _memoDetail: IMemoDetailModel
  ) => {
    let responseGroup: any[] = [];

    for (let i = 0; i < dataGroup.length; i++) {
      const dataSource: any = dataGroup[i].dataGroup;

      for (let j = 0; j < dataSource.length; j++) {
        let dataJson: any[] = [];

        let jsonValue: any = JSON.parse(dataSource[j].jsonValue);
        const objectkeyList: any[] =
          jsonValue.conditions?.length > 0
            ? jsonValue.conditions?.filter((item: any) => {
              return item.objectkey !== undefined;
            })
            : [];
        if (objectkeyList.length > 0) {
          for (let k = 0; k < objectkeyList.length; k++) {
            if (objectkeyList[k].objectkey && _memoDetail) {
              dataJson.push({
                logicid: dataSource[j].data,
                Key: jsonValue.conditions[k].objectkey,
                Value: getValueControl(
                  jsonValue.conditions[k].objectkey,
                  _memoDetail
                ),
              });
            }
          }
        } else {
          dataJson.push({
            logicid: dataSource[j].data,
            key: "",
            value: "",
          });
        }

        if (dataJson.length > 0) {
          await fetch(
            "api/TemplateList/TemplateByid/LoadLogic/GetLoadDataFormControl2",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              // test json
              body: JSON.stringify(dataJson),
            }
          )
            .then((response) => response.json())
            .then((data) => {
              if (!dataSource[j].isInTable) {
                responseGroup.push({
                  isInTable: dataSource[j].isInTable,
                  data: data,
                  labelactionfield: jsonValue.labelactionfield,
                  row: dataSource[j].row,
                  col: dataSource[j].col,
                });
              } else {
                responseGroup.push({
                  isInTable: dataSource[j].isInTable,
                  tableColumn: dataSource[j].tableColumn,
                  labelactionfield: jsonValue.labelactionfield,
                  data: data,
                  row: dataSource[j].row,
                  col: dataSource[j].col,
                });
              }
            });
        }
      }
    }

    return responseGroup;
  };
  useEffect(() => {
    if (memoDetail) {
      setTimeout(() => {
        if (!isEmptyObject(requestor)) {
          checkedLeaveTemplateLogic(requestor);
        }

        if (
          memoDetail?.status === "New Request" &&
          masterSetting["ComConfig"]?.Value1 === "blank"
        ) {
          if (memoDetail.company_name !== "") {
            memoDetail.company_name = "";
            memoDetail.company_id = 0;
            console.log(requestor);
            setMemoDetail((prevState: any) => ({
              ...prevState,
              ...memoDetail,
            }));
          }
        } else if (
          memoDetail?.memoid === 0 &&
          masterSetting["ComConfig"]?.Value1 !== "blank"
        ) {
          if (memoDetail?.checkChangeComp !== true) {
            if (
              requestor.CompanyNameTh === "" ||
              requestor.CompanyNameEn === ""
            ) {
              if (masterCompanies.length === 1) {
                let com_name = masterCompanies[0].CompanyCode + " : ";
                if (userData.Lang === "EN") {
                  com_name = com_name + masterCompanies[0].NameEn;
                } else {
                  com_name = com_name + masterCompanies[0].NameTh;
                }
                memoDetail.company_name = com_name;
                memoDetail.company_id = masterCompanies[0].CompanyId;
              }
            } else {
              if (userData.Lang === "EN") {
                memoDetail.company_name = requestor.CompanyNameEn;
              } else {
                memoDetail.company_name = requestor.CompanyNameTh;
              }
              memoDetail.company_id = requestor.CompanyId;
            }
          }
        }
      }, 100);
    }
  }, [isFirstRun.current, requestor]);

  async function checkedLeaveTemplateLogic(_requestor: any) {
    if (checkedLeaveTemplate) {
      var _responeData = await GetLeaveTemplateByEmpId(_requestor.EmployeeId);

      setLeaveTypeTable(_responeData);
    }
    let temp: any = memoDetail?.template_desc;
    if (allLogic.length > 0) {
      temp = await prepareInitialLogic(
        allLogic,
        memoDetail.template_desc,
        memoDetail,
        memoDetail.status,
        memoDetail.requestor
      );
      // memoDetail.template_desc = temp;
      setMemoDetail((prevState: any) => ({
        ...prevState,
        template_desc: temp,
      }));
    }
    // for MBK SITE only
    if (mbkOnlyU !== null && mbkOnlyU.length > 0) {
      if (mbkOnlyU[0].Value1 === "True") {
        reset(temp);
      }
    }
  }

  //process datalineapprove logic
  const onProcessLogicLineApprove = async (
    logic: ILogic,
    controlTemplate: any,
    controlValue: any,
    control: any
  ) => {
    const jsonValue: ILogicTypeDataLineApprove =
      logic.jsonvalue &&
      logic.jsonvalue.length > 0 &&
      JSON.parse(logic.jsonvalue.replace(`},\r\n],`, "}],"));

    const conditionsValue = onFilterCondotionsValue(
      jsonValue,
      control,
      controlTemplate,
      controlValue
    );

    if (conditionsValue.length > 0) {
      return JSON.stringify({
        logicid: logic.logicid,
        conditions: conditionsValue,
      });
    }
    return false;
  };

  const onFilterCondotionsValue = (
    jsonValue: ILogicTypeDataLineApprove,
    _control: any,
    controlTemplate: any,
    controlValue: any
  ) => {
    let conditions: { label: string; value: string; action?: string }[] = [];
    for (let i = 0; i < jsonValue?.Conditions?.length; i++) {
      const condition = jsonValue?.Conditions[i];
      const isNumberInput = controlTemplate.type === "c";
      if (condition.label === controlTemplate.label) {
        conditions.push({
          label: condition.label,
          value: controlValue
            ? isNumberInput
              ? controlValue.toLocaleString()
              : controlValue
            : "0",

          action: condition.action,
        });
      } else {
        for (let j = 0; j < _control.length; j++) {
          const item = _control[j];

          for (let k = 0; k < item.layout.length; k++) {
            const layout = item.layout[k];

            if (
              condition.label === layout.template.label &&
              layout.template.label !== controlTemplate.label
            ) {
              conditions.push({
                label: condition.label,
                value: layout.data.value
                  ? isNumberInput
                    ? layout.data.value.toLocaleString()
                    : layout.data.value
                  : "0",
                action: condition.action,
              });
            }
          }
        }
      }
    }
    return conditions;
  };

  async function renderSelectedRequestor(_requestor: any) {
    try {
      // initial save JsonCondition(logictype="datalineapprove") when change requestor
      // when change requestor the current level must be 0
      setMemoDetail((prevState: any) => ({
        ...prevState,
        current_approval_level: 0,
      }));
      const _control = getValues();

      if (checkActionPage) {
        if (memoDetail) {
          let allTemplateControl: any;
          if (memoDetail.template_desc.items) {
            allTemplateControl = memoDetail.template_desc.items.map(
              (item: any) => {
                return item;
              }
            );
          } else {
            allTemplateControl = "";
          }
          const logicRefInfomation = allLogic.filter((item: any) => {
            return item.logictype === "refinfomation";
          });
          //  //if change requestor run allLogic
          if (logicRefInfomation.length > 0) {
            if (_control) {
              const temp = memoDetail;
              for (let i = 0; i < _control.items?.length; i++) {
                const templateItems = _control.items[i];
                for (let j = 0; j < templateItems.layout.length; j++) {
                  const _layout = templateItems.layout[j];
                  if (_layout.template.type !== "tb") {
                    logicRefInfomation.forEach(async (refInfor: any) => {
                      const logicRefInformation = JSON.parse(
                        refInfor.jsonvalue
                      );
                      if (
                        _layout.template.label === logicRefInformation.condition
                      ) {
                        if (
                          logicRefInformation.required ===
                          "Requestor_Employee_code"
                        ) {
                          _layout.data.value = _requestor.EmployeeCode;
                        } else if (
                          logicRefInformation.required === "Requestor_Name"
                        ) {
                          if (_requestor.DefaultLang === "EN") {
                            _layout.data.value = _requestor.NameEn;
                          } else {
                            _layout.data.value = _requestor.NameTh;
                          }
                        } else if (
                          logicRefInformation.required === "Requestor_Positon"
                        ) {
                          if (_requestor.DefaultLang === "EN") {
                            _layout.data.value = _requestor.PositionNameEn;
                          } else {
                            _layout.data.value = _requestor.PositionNameTh;
                          }
                        } else if (
                          logicRefInformation.required === "Requestor_Division"
                        ) {
                          if (_requestor.DefaultLang === "EN") {
                            _layout.data.value = _requestor.DivisionNameEn;
                          } else {
                            _layout.data.value = _requestor.DivisionNameTh;
                          }
                        } else if (
                          logicRefInformation.required ===
                          "Requestor_Department"
                        ) {
                          if (_requestor.DefaultLang === "EN") {
                            _layout.data.value = _requestor.DepartmentNameEn;
                          } else {
                            _layout.data.value = _requestor.DepartmentNameTh;
                          }
                        } else if (
                          logicRefInformation.required === "Requestor_Email"
                        ) {
                          _layout.data.value = _requestor.Email;
                        }
                      }
                    });
                  }
                }
              }
              temp.requestor = _requestor;
              temp.template_desc = _control;

              if (allLogic.length > 0) {
                const resTemp = await prepareInitialLogic(
                  allLogic,
                  temp.template_desc,
                  temp,
                  undefined,
                  temp.requestor,
                  true
                );
                setDefaultTemplateDesc(resTemp.items);
              }
            }
          }
          const logicDataLineApprove = allLogic.find((item: any) => {
            return item.logictype === "datalineapprove";
          });

          if (logicDataLineApprove) {
            const logiceiei = JSON.parse(logicDataLineApprove.jsonvalue);
            memoDetail.template_desc.items.map(async (detail: any) => {
              const desc = detail.layout.find(
                (item: any) => item.template.label === logiceiei.label
              );
              if (desc) {
                const responseData = await onProcessLogicLineApprove(
                  logicDataLineApprove,
                  desc,
                  desc.data.value,
                  allTemplateControl
                );

                getLineApproveForAmount(
                  Number(memoDetail.amount.replaceAll(",", "")),
                  responseData,
                  "requestor",
                  undefined,
                  _requestor
                );
              }
            });
          } else {
            getLineApproveForAmount(
              Number(memoDetail.amount.replaceAll(",", "")),
              undefined,
              "requestor",
              undefined,
              _requestor
            );
          }
        }
      }
    } catch (error) {
      console.error("renderSelectedRequestor=>error", error);
    }
  }

  async function checkTemplateVersion(listFormName: any, memoDetail: any) {
    if (listFormName?.IsFormControl) {
      const _templateApproveId = Number(memoDetail.TemplateApproveId);
      let _listTemplate = await SearchTemplateListEditing({
        TemplateId: null,
        CreatedBy: userData.EmployeeId.toString(),
      });
      let _dataVersionTempVC = await getVersionTempVC();
      let arrayEditingVersion = [];
      for (let i = 0; i < _listTemplate.length; i++) {
        const element = _listTemplate[i];
        for (let j = 0; j < _dataVersionTempVC.length; j++) {
          const _element = _dataVersionTempVC[j];
          if (_element.value1 === element.DocumentCode) {
            if (_element.value3 === "Editing")
              arrayEditingVersion.push(element);
          }
        }
      }

      setTemplateListVersion(arrayEditingVersion);
      let _responseTemplate: any;
      if (memoDetail.TemplateApproveId) {
        _responseTemplate = await SearchTemplateListEditing({
          TemplateId: _templateApproveId,
        });
        if (_responseTemplate) {
          _responseTemplate = await GetTemplateById({
            TemplateId: _templateApproveId,
          });
        }

        if (_responseTemplate[0]) {
          setSelectedTemplateVersion(_responseTemplate[0]);
        } else {
          setSelectedTemplateVersion(_responseTemplate);
        }
      }
      setIsTemplateVersion(true);
    }
  }

  const checkLeaveRequestTemplate = async (template_code: string) => {
    var _lRTempCode = lRTempCode;
    if (_lRTempCode) {
      for (let index = 0; index < _lRTempCode.length; index++) {
        if (_lRTempCode[index].Value1 === template_code) {
          setCheckedLeaveTemplate(true);
        } else {
          setCheckedLeaveTemplate(false);
        }
      }
    }
  };
  const replaceTitleInfo = async (memoDetail: IMemoDetailModel) => {
    var _responeADTitle = await ADTitleConfiguration();
    if (_responeADTitle?.activeBranchFromADTitle?.toLowerCase() === "true") {
      setIsBranchFromADTitle(true);
    }
    if (_responeADTitle?.activeADTitleToPosition?.toLowerCase() === "false") {
      if (memoDetail?.requestor?.ADTitle) {
        setIsADTitleToPosition(true);
      }
    }
  };
  const checkDataAndSetFunction = async (memoDetail: IMemoDetailModel) => {
    if (!memoDetail.template_detail || !memoDetail.document_set) {
      const _guid = generateQuickGuid();
      memoDetail.template_detail = _guid;
      memoDetail.document_set = _guid;
    }

    if (memoDetail.memoid === 0) {
      if (userData.CompanyNameTh === "" || userData.CompanyNameEn === "") {
        if (masterCompanies.length === 1) {
          let com_name = masterCompanies[0].CompanyCode + " : ";
          if (userData.Lang === "EN") {
            com_name = com_name + masterCompanies[0].NameEn;
          } else {
            com_name = com_name + masterCompanies[0].NameTh;
          }
          memoDetail.company_name = com_name;
          memoDetail.company_id = masterCompanies[0].CompanyId;
        }
      } else {
        if (userData.Lang === "EN") {
          memoDetail.company_name = userData.CompanyNameEn;
        } else {
          memoDetail.company_name = userData.CompanyNameTh;
        }
        memoDetail.company_id = userData.CompanyId;
      }
    }

    if (memoDetail.project_id !== 0) {
      masterProjects.map((_item: any) => {
        if (memoDetail.project_id === _item.ProjectId) {
          setProject(_item);
        }
      });
    }
    if (memoDetail.to) {
      const _spited = memoDetail.to.split(",");
      setListInToAndPass((prevState: any) => ({
        ...prevState,
        to: _spited,
      }));
    }
    if (memoDetail.pass) {
      const _spited = memoDetail.pass.split(",");
      setListInToAndPass((prevState: any) => ({
        ...prevState,
        pass: _spited,
      }));
    }
  };
  const checkState = async (
    memoStatus: string,
    listFormName: any,
    current_approval_level: number,
    listApprovalDetails: any[],
    memoButtons: any[],
    waitForId: number
  ) => {
    let roles: number[] = await GetRolePermissionByUser().then((e) => {
      return Array.from(
        new Set(
          e
            ?.filter((r: any) => r.EmployeeId === userData.EmployeeId)
            ?.map((r: any) => r.RoleId)
        )
      );
    });
    let _memoButtons = memoButtons.filter((x) => x.commandName != "recall");
    if (
      memoStatus === "Draft" ||
      memoStatus === "New Request" ||
      memoStatus === "Rework" ||
      memoStatus === "Recall" ||
      memoStatus === "Wait for Process"
    ) {
      setCanEditDoc(true);
      setCanEditRefDoc(true);
      if (listFormName?.IsRequesterEditApproval) {
        setCanEditLineApprove(listFormName?.IsRequesterEditApproval);
      }
    } else if (
      memoStatus === "Completed" ||
      memoStatus === "Rejected" ||
      memoStatus === "Cancelled"
    ) {
      console.log(_memoButtons?.find((button)=>button.commandName ==="draftattachment"));
      const hasDraftAtt = _memoButtons?.find((button)=>button?.commandName ==="draftattachment")
      if (_memoButtons.length > 0 && !hasDraftAtt) {
        setCanEditDoc(true);
      }
      setCanEditLineApprove(false);
    } else {
      const isInSeq = (listApprovalDetails || [])
        .filter((e) => e.sequence === current_approval_level)
        .find(
          (e) => e.emp_id === userData.EmployeeId || e.emp_id === waitForId
        );
      if (isInSeq) {
        if (listFormName.ApproverCanEdit) {
          setCanEditDoc(true);
        }
        if (listFormName.IsRequesterEditApproval) {
          setCanEditLineApprove(
            listFormName.IsRequesterEditApproval && _memoButtons.length > 0
          );
        }
      }

      if (listFormName?.IsCheckAccess) {
        setIsCheckAccess(true);
      } else {
        console.log('undefined');
      }
    }

    if (roles.includes(1)) {
      setUserData({ ...userData, IsAdmin: true });
      setCanEditLineApprove(true);
    } else {
      setUserData({ ...userData, IsAdmin: false });
    }

    //Skipapm
    if (skipapm.length > 0) {
      setIsSkipapm(skipapm.some((e) => e === listFormName?.DocumentCode));
    }
  };
  async function checkRefTemplate(
    template: any,
    listRefDocDetails: any,
    refDocs: any,
    _RefID: string
  ) {
    const temp = template;
    try {
      if (temp) {
        if (temp?.RefDocDisplay && temp.RefTemplate) {
          let _refDoc: any[] = [];
          const display = temp?.RefDocDisplay.split(",");
          const _refTemplate = JSON.parse(temp.RefTemplate);
          if (display[2] !== "Information DocumentNo") {
            refDocs.map((ref: any) => {
              if (ref !== null) {
                if (display[2] !== "Information DocumentNo") {
                  ref[display[2]] = ref.SelectField.value;
                  if (typeof ref[display[2]] === "string") {
                    _refDoc.push(ref);
                  }
                }
              }
            });
          } else {
            _refDoc = refDocs;
          }

          let refObject: any = {
            option: refDocs,
            position: display[0],
            mode: display[1],
            optionLabel:
              display[2] !== "Information DocumentNo"
                ? display[2]
                : "DocumentNo",
            isDefaultLineApprove: display[4],
            refIdOnQuery: null,
          };
          if (_RefID !== "") {
            const results = _refDoc.filter(
              (refDoc: any) => refDoc.DocumentNo === _RefID
            );

            refObject.refIdOnQuery = _RefID;
            setRefTempSelected(results);
          } else if (listRefDocDetails?.length > 0) {
            const refDocsDetail: any[] = listRefDocDetails.map(
              (e: { memoRefdoc_id: any }) => e.memoRefdoc_id
            );

            let results = refDocs.filter((refDoc: any) => {
              return refDocsDetail.includes(refDoc.MemoId);
            });

            if (results.length === 0) {
              let dataJson: any[] = [];
              listRefDocDetails.forEach((e: any) => {
                userData.SignPicPath = "";
                dataJson.push({
                  memoid: e.memoRefdoc_id,
                  EmployeeId: userData.EmployeeId.toString(),
                  actor: userData,
                });
              });
              results = await GetMemoDetailOnlyById(dataJson);

              if (display[2] !== "Information DocumentNo") {
                results = results.map((ref: any) => {
                  if (ref !== null) {
                    if (display[2] !== "Information DocumentNo") {
                      try {
                        let refTemp = JSON.parse(ref.Template_desc);
                        refTemp.items.forEach((col: any) => {
                          col.layout.forEach((_layout: any) => {
                            if (_layout.template.label === display[2]) {
                              if (_layout.template.type === "c") {
                                ref[display[2]] = Number(
                                  _layout.data.value
                                ).toLocaleString("en-US", {
                                  minimumFractionDigits: Number(
                                    _layout.template.attribute.decimal
                                  ),
                                });
                              } else {
                                if (_layout.data.value) {
                                  ref[display[2]] = _layout.data.value;
                                } else {
                                  ref[display[2]] = null;
                                }
                              }
                            }
                          });
                        });

                        if (typeof ref[display[2]] === "string") {
                          let res: any = {
                            MemoId: ref.Memoid,
                            เลขที่เอกสาร: ref.doc_no,
                            TemplateName: ref.Template_name,
                            MemoSubject: ref.Subject,
                          };
                          res[display[2]] = ref[display[2]];
                          return res;
                        }
                      } catch (error) {
                        console.error("ref=>error", error);
                      }
                    }
                  }
                });
                setRefTempSelected([...results]);
              } else {
                const selected = results.map(
                  (e: {
                    Memoid: any;
                    Document_no: any;
                    Template_name: any;
                    Subject: any;
                  }) => {
                    let refDoc: any = {
                      MemoId: e.Memoid,
                      [refObject.optionLabel]: e.Document_no,
                      TemplateName: e.Template_name,
                      MemoSubject: e.Subject,
                    };
                    return refDoc;
                  }
                );

                setRefTempSelected([...selected]);
              }
            } else {
              setRefTempSelected([
                ...results.map((e: any) => {
                  let refDoc: any = {
                    MemoId: e.MemoId,
                    [refObject.optionLabel]: e[refObject.optionLabel],
                    TemplateName: e.TemplateName,
                    MemoSubject: e.MemoSubject,
                  };
                  return refDoc;
                }),
              ]);
            }

          }

          setRefAttribute({ ...refObject });
          setSearchRefDocData([..._refDoc]);
        } else {
          setRefTempSelected([]);
          setRefAttribute(undefined);
        }
      }
    } catch (error) { }
  }

  const print = () => {
    if (process.env.NODE_ENV === "development") {
      // console.log("---------------------MemoPage Value-----------------------");
      console.log("memoDetail=>", memoDetail);
      // console.log("checkActionPage=>", checkActionPage);
      // console.log({ errors });
      console.log("lineApproval=>", lineApproval);
      console.log("listFormNames=>", listFormNames);
      // console.log("listHistoryDetails=>", listHistoryDetails);
      // console.log("listFileAttachDetails=>", listFileAttachDetails);
      // console.log("listRefDocDetails=>", listRefDocDetails);
      // console.log("---------------------RefDoc Attibute-----------------------");
      //console.log("refAttibute=>", refAttribute);
      //console.log("refTempSelected=>", refTempSelected);
      //console.log("searchRefDocData=>", searchRefDocData);

      // console.log("---------------------MasterData-----------------------");
      // console.log("masterSignature=>", masterSignature);
      // console.log("validField", masterDataValidField);
      // console.log("masteProjects=>", masteProjects);
      // console.log("masteEmployee=>", masteEmployee);
      // console.log("masteCompanies=>", masteCompanies);
      // console.log("searchTemplateListEditing=>", searchTemplateListEditing);
      // console.log("menuButton=>", menuButton);
      console.log("allLogic=>", allLogic);
      // console.log("finFo=>", finFo);
      // console.log("listRefDocs=>", listRefDocs);
      // console.log("---------------------Can Edit-----------------------");
      console.log("canEditDoc=>", canEditDoc);
      // console.log("table=>tableSummaries", tableSummaries);
      // console.log("autoNumFormat=>", autoNumFormat);
    }
  };
  function dataGetInformationMethodMemoProp(
    listFormName: any,
    memoDetail: IMemoDetailModel
  ) {
    memoDetail.memoid = 0;
    memoDetail.request_date = moment(new Date()).format("DD/MM/YYYY HH:mm:ss");
    memoDetail.created_date = moment(new Date()).format("DD/MM/YYYY HH:mm:ss");
    memoDetail.status = "New Request";
    memoDetail.modified_date = moment(new Date()).format("DD/MM/YYYY HH:mm:ss");
    memoDetail.modified_by = userData.EmployeeId.toString();
    memoDetail.created_by = userData.EmployeeId.toString();
    memoDetail.creator = userData;
    memoDetail.requestor = userData;
    memoDetail.report_lang = listFormName?.ReportLang;
    memoDetail.auto_approve = listFormName?.AutoApprove;
    memoDetail.auto_approve_when = listFormName?.AutoApproveWhen;
    memoDetail.GroupTemplateName = listFormName?.GroupTemplateName;
    memoDetail.template_id = listFormName?.TemplateId;
    memoDetail.template_name = listFormName?.TemplateName;
    memoDetail.template_code = listFormName?.DocumentCode;
    memoDetail.document_no = "Auto Generate";
    memoDetail.waiting_for = userData.NameTh;
    memoDetail.waiting_for_id = userData.EmployeeId;
    memoDetail.company_name = "";
    memoDetail.company_id = 0;
    memoDetail.project_id = 0;
    memoDetail.project = "";
    memoDetail.subject = listFormName?.TemplateSubject;
    memoDetail.amount = "";
    memoDetail.to = listFormName?.ToId;
    memoDetail.pass = listFormName?.CcId;
  }

  function toggleSideBar() {
    setSidebarState(!sidebarState);
  }

  const onSelectView = (text: string) => {
    setCurPage(text);
    setSelectedView(text);
  };

  const createTableSums = (templateDesc: any) => {
    let sumIntable: any[] = [];
    templateDesc?.items?.forEach((item: any) => {
      item.layout.forEach((layout: any) => {
        if (layout.template.type === "tb") {
          const cols = layout.template.attribute.column;
          let sum: any = {};
          cols.forEach((e: any) => {
            if (e.control.template.type === "c") {
              sum[e.label] = 0;
            }
          });
          sumIntable.push({ tableTemp: layout.template, AllCol: sum });
        }
      });
    });
    console.log("Tablesum", [...sumIntable]);

    setTableSummaries([...sumIntable]);
  };

  function CheckValidField(formData: any) {
    const getCheckValid = [];
    let datepicker1: any;
    let datepicker2: any;
    let datepickerLabel1: any;
    let datepickerLabel2: any;
    if (
      Array.isArray(masterDataValidField) &&
      masterDataValidField[0] != null
    ) {
      try {
        const ValidField = masterDataValidField[0];
        const masterDataValid = ValidField?.Value2?.split("|");
        if (masterDataValid?.length) {
          const masterDataLabel1 = masterDataValid[0]?.toString();
          const masterDataLabel2 = masterDataValid[1]?.toString();
          setMessageValidField(masterDataValidField[0].Value4);
          formData.items.map((item: any) => {
            item.layout.map((layout: any) => {
              if (layout.template.label === masterDataLabel1) {
                datepicker1 = layout;
                datepickerLabel1 = datepicker1.template.label;
              }
              if (layout.template.label === masterDataLabel2) {
                datepicker2 = layout;
                datepickerLabel2 = datepicker2.template.label;
              }
            });
          });
          if (
            datepickerLabel1 === masterDataLabel1 &&
            datepickerLabel2 === masterDataLabel2 &&
            masterDataLabel2 !== undefined
          ) {
            let newDate1 = new Date(datepicker1.data.value);
            let newDate2 = new Date(datepicker2.data.value);
            getCheckValid.push(newDate1, newDate2);
          }
        }
      } catch (error) {
        console.error("masterDataValid=>error", error);
      }
    }
    return getCheckValid;
  }

  const onSubmit = async (formData: any, data: IRequestOnSubmit) => {
    // variables RequestScreen
    const _submitType = data.buttonType;
    let _memoDetail: IMemoDetailModel = memoDetail;
    let _lineApproval: any[] = lineApproval;
    let dateValidField1: any = CheckValidField(formData)[0];
    let dateValidField2: any = CheckValidField(formData)[1];
    let _listHistoryDetails: any[] = listHistoryDetails;
    let _listFileAttachDetails: any[] = listFileAttachDetails;
    let _listRefDocDetails: any[] = listRefDocDetails;
    let _listControlRunning: any[] = [];
    let _listFormNames = listFormNames;
    let _userData: IUserModel = userData;

    // variables Information
    let _listInToAndPass: any = listInToAndPass;
    let _project: any = project;
    let _tempVersion: any = selectedTemplateVersion;
    const _allLogic = allLogic;
    let message: any = masterDataValidField
      ? masterDataValidField[0]
        ? masterDataValidField[0].Value4
        : ""
      : "";

    // test validation
    const _validation = Validation(
      _submitType,
      memoDetail,
      lineApproval,
      dateValidField1,
      dateValidField2,
      message
    );
    console.log(
      _validation,
      _submitType,
      memoDetail,
      lineApproval,
      dateValidField1,
      dateValidField2,
      message
    );

    if (
      _submitType !== "draft" &&
      _submitType !== "cancel" &&
      _submitType !== "reject" &&
      _submitType !== "recall" &&
      _submitType !== "assign" &&
      isRequireAttachment &&
      _listFileAttachDetails.length === 0
    ) {
      toggleAlert({
        description: `Required Attachment`,
        message: `Required Attachment.`,
        type: "warning",
      });
      return;
    }

    setLoad(true);

    if (!isTextFromValue) {
      CheckValidField(formData);
      formData.items.map((item: any) => {
        item.layout.map((layout: any) => {
          if (layout.template.type === "tb") {
            if (
              Object.keys(isDirtyOfTable).length > 0 &&
              isDirtyOfTable[layout.template.label] != null
            ) {
              // Handle the case where isDirtyOfTable is empty, if needed
              layout.data.row?.map((row: any, idx: number) => {
                if (isDirtyOfTable[layout.template.label][idx]) {
                  row.map((col: any, colIndex: any) => {
                    if (isDirtyOfTable[layout.template.label][idx][colIndex]) {
                      col.isDirty = true;
                    }
                  });
                }
              });
            }
          }
          if (layout.data.value === null) {
            layout.data.value = layout.template?.attribute?.default;
          }
        });
      });

      const formatFormData = formData?.items?.map((item: any) => {
        return {
          ...item,
          layout: item.layout?.map((_layout: any) => {
            if (_layout.template.type === "l") {
              return {
                ..._layout,
                template: {
                  ..._layout.template,
                  ["attribute"]: null,
                },
              };
            } else {
              return _layout;
            }
          }),
        };
      });

      _memoDetail.template_desc = JSON.stringify({
        ...masterTemplateDesc,
        items: formatFormData,
      });
    } else {
      _memoDetail.is_text_form = true;
      _memoDetail.template_desc = textFromValue;
    }

    if (!memoDetail.template_detail || !memoDetail.document_set) {
      const _guid = generateQuickGuid();
      memoDetail.template_detail = _guid;
      memoDetail.document_set = _guid;
    }

    if (_validation.length >= 1) {
      toggleAlert({
        description: `Please fill ${_validation.join(" , ")}`,
        message: `Require field warning.`,
        type: "warning",
      });
      setLoad(false);
      return;
    }

    // Set values
    _memoDetail.comment = data?.inputComment || "";
    _memoDetail.waiting_for = data?.waitingFor || _userData.NameTh;
    _memoDetail.waiting_for_id = data?.waitingForId || _userData.EmployeeId;
    _memoDetail.to = _listInToAndPass.to.join(",");
    _memoDetail.pass = _listInToAndPass.pass.join(",");
    _memoDetail.project_id = _project?.ProjectId || 0;
    _memoDetail.project = _project?.ProjectName || "";
    _memoDetail.TemplateApproveId = _tempVersion?.TemplateId || null;
    _memoDetail.actor = _userData;
    _memoDetail.GroupTemplateName = _listFormNames.GroupTemplateName;
    _memoDetail.template_name = _listFormNames.template_name;

    if (
      autoNumFormat.rowIndex !== -1 &&
      _memoDetail.status === "New Request" &&
      _submitType !== "rework" &&
      _submitType !== "recall" &&
      _submitType !== "return" &&
      _submitType !== "reply"
    ) {
      const runningNumber = await CheckSaveAutonumber(formData);
      if (runningNumber) {
        _listControlRunning.push(runningNumber);
      }
    }

    if (_listFormNames.IsCheckAccess) {
      if (_memoDetail?.actorCheckAccess) {
        const checkAccessRequestModel = {
          memoid: _memoDetail.memoid?.toString(),
          RequesterId: null,
        };

        if (canEditDoc) {
          setCanEditDoc(false);
        }
      }
    }

    const _requestMemoPage = {
      MemoPage: {
        listApprovalDetails: _lineApproval,
        listFileAttachDetails: _listFileAttachDetails,
        listFormName: [_listFormNames],
        listHistoryDetails: _listHistoryDetails,
        listRefDocDetails: _listRefDocDetails,
        memoDetail: _memoDetail,
        listControlRunning: _listControlRunning,
        UserPrincipalName: userData.Email,
        listLogic: _allLogic,
      },
      Type: _submitType,
    };

    try {
      let _respone = await ActionMemoPage(_requestMemoPage);

      if (
        _respone?.messageType?.toLowerCase() === "success" ||
        _respone?.message?.toLowerCase().includes("done")
      ) {
        if (checkActionPage === "edit" && _submitType === "draft") {
          if (_memoDetail?.actorCheckAccess) {
            checkQuery();
          } else {
            const history = await GetMemoHistoryDetail({
              memoid: memoId,
              actor: userData,
            });
            setListHistoryDetails([...history]);
          }
          setLoadingPDF(!loadingPDF);
          toggleAlert({
            description: (
              <div
                dangerouslySetInnerHTML={{
                  __html: _respone.message,
                }}
              />
            ),
            message: _submitType,
            type: "success",
            duration: 15,
          });
        } else {
          toggleAlert({
            description: (
              <div
                dangerouslySetInnerHTML={{
                  __html: _respone.message,
                }}
              />
            ),
            message: _submitType,
            type: "success",
            duration: 15,
          });
          history.push("/Default", {
            responeData: _respone,
            msg: `${_submitType} Success`,
          });
        }

        setLoad(false);
      } else if (
        _respone?.messageType?.toLowerCase() === "error" &&
        _respone?.memoid
      ) {
        toggleAlert({
          description: (
            <div
              dangerouslySetInnerHTML={{
                __html: _respone.message,
              }}
            />
          ),
          message: `${_submitType} error.`,
          type: "error",
          duration: 15,
        });
        history.push(`/Request?MemoID=${_respone.memoid}`, _respone.memoid);
        if (_memoDetail?.actorCheckAccess) {
          checkQuery();
        } else {
          const history = await GetMemoHistoryDetail({
            memoid: memoId,
            actor: userData,
          });
          setListHistoryDetails([...history]);
        }
        setLoadingPDF(!loadingPDF);
      } else {
        toggleAlert({
          description: (
            <div
              dangerouslySetInnerHTML={{
                __html: _respone.message,
              }}
            />
          ),
          message: `${_submitType} error.`,
          type: "error",
          duration: 15,
        });
      }
      setLoad(false);
    } catch (error: any) {
      toggleAlert({
        description: `Error: ${error.message}`,
        message: `Error processing request.`,
        type: "error",
      });
      setLoad(false);
    }
  };

  const onSubmitInterface = async (
    formData: any,
    data: IRequestOnSubmit,
    setLoadingInterface: any
  ) => {
    // variables RequestScreen

    const _submitType = data.buttonType;
    let _memoDetail: IMemoDetailModel = memoDetail;
    let _lineApproval: any[] = lineApproval;
    let _listHistoryDetails: any[] = listHistoryDetails;
    let _listFileAttachDetails: any[] = listFileAttachDetails;
    let _listRefDocDetails: any[] = listRefDocDetails;
    let _listControlRunning: any[] = [];
    let _listFormNames = listFormNames;
    let _userData: IUserModel = userData;
    // variables Information
    let _listInToAndPass: any = listInToAndPass;
    let _project: any = project;
    let _tempVersion: any = selectedTemplateVersion;
    const _allLogic = allLogic;

    if (!isTextFromValue) {
      CheckValidField(formData);
      formData.items.map((item: any) => {
        item.layout.map((layout: any) => {
          if (layout?.data?.value === null) {
            layout.data.value = layout.template?.attribute?.default;
          }
        });
      });

      const formatFormData = formData?.items?.map((item: any) => {
        return {
          ...item,
          layout: item.layout?.map((_layout: any) => {
            if (_layout.template.type === "l") {
              return {
                ..._layout,
                template: {
                  ..._layout.template,
                  ["attribute"]: null,
                },
              };
            } else {
              return _layout;
            }
          }),
        };
      });

      _memoDetail.template_desc = JSON.stringify({ items: formatFormData });
    } else {
      _memoDetail.is_text_form = true;
      _memoDetail.template_desc = textFromValue;
    }

    setLoadingInterface(true);

    //set Value
    _memoDetail.comment = data?.inputComment || "";
    _memoDetail.waiting_for = data?.waitingFor || _userData.NameTh;
    _memoDetail.waiting_for_id = data?.waitingForId || _userData.EmployeeId;
    _memoDetail.to = _listInToAndPass.to.join(",");
    _memoDetail.pass = _listInToAndPass.pass.join(",");
    _memoDetail.project_id = _project?.ProjectId || 0;
    _memoDetail.project = _project?.ProjectName || "";
    _memoDetail.TemplateApproveId = _tempVersion?.TemplateId || null;
    _memoDetail.actor = _userData;

    if (
      autoNumFormat.rowIndex !== -1 &&
      _memoDetail.status === "New Request" &&
      _submitType !== "rework" &&
      _submitType !== "recall" &&
      _submitType !== "return" &&
      _submitType !== "reply"
    ) {
      const runningNumber = await CheckSaveAutonumber(formData);
      if (runningNumber) {
        _listControlRunning.push(runningNumber);
      }
    }
    if (_listFormNames.IsCheckAccess) {
      if (_memoDetail?.actorCheckAccess) {
        const checkAccessRequestModel = {
          memoid: _memoDetail.memoid?.toString(),
          RequesterId: null,
        };

        if (canEditDoc) {
          setCanEditDoc(false);
        }
      }
    }

    const _requestMemoPage = {
      MemoPage: {
        listApprovalDetails: _lineApproval,
        listFileAttachDetails: _listFileAttachDetails,
        listFormName: [_listFormNames],
        listHistoryDetails: _listHistoryDetails,
        listRefDocDetails: _listRefDocDetails,
        memoDetail: _memoDetail,
        listControlRunning: _listControlRunning,
        listLogic: _allLogic,
      },
      Type: _submitType,
    };
    let _respone = await SpecialActions(_requestMemoPage);
    try {
      if (_respone != undefined) {
        if (_respone.messageType.toLowerCase() == "success") {
          toggleAlert({
            description: (
              <div
                dangerouslySetInnerHTML={{
                  __html: _respone.message,
                }}
              />
            ),
            message: _submitType,
            type: "success",
            duration: 15,
          });
        } else if (_respone.messageType.toLowerCase() == "error") {
          toggleAlert({
            description: (
              <div
                dangerouslySetInnerHTML={{
                  __html: _respone.message,
                }}
              />
            ),
            message: _submitType,
            type: "error",
            duration: 15,
          });
        } else if (_respone.messageType.toLowerCase() == "warning") {
          toggleAlert({
            description: (
              <div
                dangerouslySetInnerHTML={{
                  __html: _respone.message,
                }}
              />
            ),
            message: _submitType,
            type: "warning",
            duration: 15,
          });
        }
        if (_respone.data) {
          setTemplate_desc(_respone.des);
          let _templateDesc = JSON.parse(_respone.data);
          setLoadingInterface(false);
          return _templateDesc.items;
        }
      }
      setLoadingInterface(false);
    } catch (error) {
      console.error("error", error);
    }
  };

  const IsCheckAccessEditing = () => {
    let isCheck = false;
    if (memoDetail?.actorCheckAccess?.EmployeeId === userData.EmployeeId) {
      isCheck = true;
    }
    return isCheck;
  };

  const CheckSaveAutonumber = async (template_desc: any) => {
    try {
      const rowIndex = autoNumFormat.rowIndex;
      const colIndex = autoNumFormat.colIndex;
      if (template_desc?.items[rowIndex]?.layout[colIndex].isShow) {
        if (template_desc) {
          let value =
            template_desc?.items[rowIndex]?.layout[colIndex]?.data?.value;
          const autoTemp = template_desc?.items[rowIndex]?.layout[colIndex];
          if (value) {
            let requestBody = null;
            let newRunning = -1;
            if (autoNumFormat.showSymbol) {
              const dd = value.split("-");
              const gg = dd.slice(0, dd.length - 1);
              requestBody = {
                Prefix: gg.join("-") + "-",
                Digit: autoTemp.template.digit,
                TemplateId: memoDetail.template_id,
                RunningNumber: dd.join("-"),
              };
              const checkAuto = await GetSaveRunningNumber(requestBody);
              const checkNum = checkAuto.split("-");
              if (checkNum[0] !== "") {
                newRunning = checkNum[checkNum.length - 1];
                dd[dd.length - 1] = newRunning;
                requestBody.RunningNumber = gg.join("-") + "-" + newRunning;
              }
            } else {
              requestBody = {
                Prefix: autoNumFormat.fisrtPreix,
                Digit: autoTemp.template.digit,
                TemplateId: memoDetail.template_id,
                RunningNumber: value,
              };
              const checkAuto = await GetSaveRunningNumber(requestBody);
              const checkNum = checkAuto.replaceAll(
                autoNumFormat.fisrtPreix,
                ""
              );
              let dd = value.replaceAll(autoNumFormat.fisrtPreix, "");
              if (checkNum !== "") {
                newRunning = checkNum;
                dd = newRunning;
                if (autoNumFormat?.fisrtPreix) {
                  requestBody.RunningNumber =
                    autoNumFormat?.fisrtPreix + newRunning;
                }
              }
            }

            return requestBody;
          }
        }
      }
    } catch (error) {
      console.error("auto=>CheckSaveAutonumber=>error", error);
    }
  };

  if (!memoDetail) {
    return <></>;
  }

  return (
    <div className="request-main-container">
      <div className="request-container">
        <Toast ref={toast} />
        <div className="header-request set-z-index">
          <div className="button-container">
            <Button
              className="btn-sidebar-request"
              type="text"
              icon={<IoMenu size={28} />}
              size="large"
              onClick={toggleSideBar}
              style={{ background: "transparent " }}
            />
          </div>{" "}
          <TreeSelectNewRequest
            setDataTemplateTreeProps={setDataTreeSelectProps}
          />
          {!isLoad && muduleRequest?.requestable && (
            <div
              className={
                memoDetail?.actorCheckAccess
                  ? IsCheckAccessEditing()
                    ? "confirm-container"
                    : "checkaccess-container"
                  : "confirm-container"
              }
            >
              {checkActionPage === "add" && (
                <div className="memo-button-container">
                  <MemoSingleButton
                    handleSubmit={handleSubmit}
                    onSubmit={onSubmit}
                    pageName={"Request"}
                    type="submit"
                    buttonType={buttonType}
                    setButtonType={setButtonType}
                    setSelectedView={setSelectedView}
                    setCurPage={setCurPage}
                    lineApproval={lineApproval}
                    approvalSequence={memoDetail.current_approval_level}
                  />
                  <MemoSingleButton
                    handleSubmit={handleSubmit}
                    onSubmit={onSubmit}
                    pageName={"Request"}
                    type="draft"
                    buttonType={buttonType}
                    setButtonType={setButtonType}
                    setSelectedView={setSelectedView}
                    setCurPage={setCurPage}
                    lineApproval={lineApproval}
                    approvalSequence={memoDetail.current_approval_level}
                  />
                </div>
              )}

              {((checkActionPage === "edit" && !memoDetail?.actorCheckAccess) ||
                IsCheckAccessEditing()) && (
                  <MemoButtonComponent
                    setSelectedView={setSelectedView}
                    memoMenu={menuButton}
                    handleSubmit={handleSubmit}
                    onSubmit={onSubmit}
                    pageName={"Request"}
                    buttonType={buttonType}
                    setButtonType={setButtonType}
                    setCurPage={setCurPage}
                    lineApproval={lineApproval}
                    approvalSequence={memoDetail.current_approval_level}
                  />
                )}
              {checkActionPage === "edit" && (
                <>
                  {loadingPDF && (
                    <OtherButtonMemoComponent
                      pdfData={location.state?.pdfData}
                      memoIdForCopy={
                        query.get("MemoID") ? query.get("MemoID") : ""
                      }
                      isCheckAcces={isCheckAccess}
                      memoDetail={{
                        listApprovalDetails: lineApproval,
                        listFileAttachDetails: listFileAttachDetails,
                        listFormNames: [listFormNames],
                        listHistoryDetails: listHistoryDetails,
                        listRefDocDetails: listRefDocDetails,

                        memoDetail: {
                          ...memoDetail,
                          template_desc: memoDetail.template_desc
                            ? typeof memoDetail.template_desc === "object"
                              ? JSON.stringify(memoDetail.template_desc)
                              : memoDetail.template_desc
                            : null,
                        },
                      }}
                      canEdit={canEditDoc}
                      setCanEdit={setCanEditDoc}
                      isControlLoading={isControlLoading}
                      setIsControlLoading={setIsControlLoading}
                      permission={permission}
                    />
                  )}
                  {!loadingPDF && (
                    <OtherButtonMemoComponent
                      memoDetail={{
                        listApprovalDetails: lineApproval,
                        listFileAttachDetails: listFileAttachDetails,
                        listFormNames: [listFormNames],
                        listHistoryDetails: listHistoryDetails,
                        listRefDocDetails: listRefDocDetails,
                        memoDetail: {
                          ...memoDetail,
                          template_desc:
                            typeof memoDetail.template_desc === "object"
                              ? JSON.stringify(memoDetail.template_desc)
                              : memoDetail.template_desc,
                        },
                      }}
                      pdfData={location.state?.pdfData}
                      memoIdForCopy={
                        query.get("MemoID") ? query.get("MemoID") : ""
                      }
                      isCheckAcces={isCheckAccess}
                      canEdit={canEditDoc}
                      setCanEdit={setCanEditDoc}
                      isControlLoading={isControlLoading}
                      setIsControlLoading={setIsControlLoading}
                      permission={permission}
                    />
                  )}
                </>
              )}
            </div>
          )}
          <div></div>
        </div>
        {!isLoad && (
          <>
            {sidebarState ? (
              <div className="show-tablet-navbar-request-min-1024">
                <RequestSideBarElement
                  onSelectView={onSelectView}
                  curPage={curPage}
                  workList={memoDetail?.memoid}
                  requestData={requestDetail}
                />
              </div>
            ) : (
              <div></div>
            )}
            <div className="inner-content">
              <div className="worklist-items-container">
                {sidebarState && (
                  <motion.div
                    className="inner-content show-tablet-navbar-request-max-1024"
                    initial={{ opacity: 0, x: -100 }}
                    animate={{ opacity: 1, x: 0 }}
                    exit={{ opacity: 0, x: -200 }}
                    transition={{ duration: 0.2 }}
                  >
                    <div className="filter-container">
                      <RequestSideBarElement
                        onSelectView={onSelectView}
                        curPage={curPage}
                        workList={memoDetail?.memoid}
                        requestData={requestDetail}
                      />
                    </div>
                  </motion.div>
                )}
                <AnimatePresence exitBeforeEnter>
                  <motion.div
                    layout
                    className="request-container-item"
                    style={{ width: sidebarState ? "82%" : "100%" }}
                    onClick={() => print()}
                    key={selectedView}
                    initial={{ x: 10, opacity: 0 }}
                    // whileFocus={{transition: {duration: 0}}}
                    animate={{ x: 0, opacity: 1 }}
                    exit={{ x: -10, opacity: 0 }}
                    transition={{ duration: duration }}
                  >
                    {selectedView === "1" && (
                      <RequestorComponent
                        userData={userData}
                        renderSelectedRequestor={renderSelectedRequestor}
                        onLoadDataLiveApprove={onLoadDataLiveApprove}
                        lineApproval={lineApproval}
                        jsonCondition={jsonConditions}
                        memoDetail={memoDetail}
                        setMemoDetail={setMemoDetail}
                        canEditDoc={canEditDoc}
                        masterEmployee={masterEmployee}
                        setLineApproval={setLineApproval}
                        isADTitleToPosition={isADTitleToPosition}
                        requestor={requestor}
                        creator={creator}
                        setRequestor={setRequestor}
                        t={t}
                      />
                    )}
                    {selectedView === "2" && (
                      <InformationComponentFix
                        listFormNames={listFormNames}
                        setListRefDocDetails={setListRefDocDetails}
                        numFormulas={numFormulas}
                        canEditRefDoc={canEditRefDoc}
                        refLoading={refLoading}
                        setLineApproval={setLineApproval}
                        setListFileAttachDetails={setListFileAttachDetails}
                        returnMessage={returnMessage}
                        listReturn={listReturn}
                        onBlurProps={() => setDuration(0.2)}
                        onFocusProps={() => setDuration(0)}
                        {...{
                          trigger,
                          getValues,
                          tableOptions,
                          setTableOptions,
                          onProcessLogicReference,
                          refOptions,
                          prepareInitialLogic,
                          isFirstRun,
                          previousRefTempSelected,
                          isShowSum,
                          previousView,
                          buttonType,
                          control,
                          register,
                          handleSubmit,
                          onSubmit,
                          onSubmitInterface,
                          errors,
                          setDefaultTemplateDesc,
                          onControlChange,
                          allLogic,
                          reset,
                          memoDetail,
                          jsonConditions,
                          setJsonConditions,
                          setValue,
                          canEditDoc,
                          checkActionPage,
                          isControlLoading,
                          setIsControlLoading,
                          tableSummaries,
                          setTableSummaries,
                          updateIsDirtyOfTable,
                        }}
                        memoDetail={memoDetail}
                        setMemoDetail={setMemoDetail}
                        masterCompanies={masterCompanies}
                        masterEmployee={masterEmployee}
                        setListInToAndPass={setListInToAndPass}
                        listInToAndPass={listInToAndPass}
                        masterProjects={masterProjects}
                        setProject={setProject}
                        project={project}
                        finFo={finFo}
                        masterInterface={masterInterface}
                        isBranchFromADTitle={isBranchFromADTitle}
                        checkedLeaveTemplate={checkedLeaveTemplate}
                        leaveTypeTable={leaveTypeTable}
                        isTextFromValue={isTextFromValue}
                        setTextFromValue={setTextFromValue}
                        textFromValue={textFromValue}
                        refTempSelected={refTempSelected}
                        setRefTempSelected={setRefTempSelected}
                        setSearchRefDocData={setSearchRefDocData}
                        searchRefDocData={searchRefDocData}
                        refAttribute={refAttribute}
                        setSelectedTemplateVersion={setSelectedTemplateVersion}
                        selectedTemplateVersion={selectedTemplateVersion}
                        templateListVersion={templateListVersion}
                        isTemplateVersion={isTemplateVersion}
                        dialogVisibleInRefTemplate={dialogVisibleInRefTemplate}
                        setDialogVisibleInRefTemplate={
                          setDialogVisibleInRefTemplate
                        }
                        getLineApproveForAmount={getLineApproveForAmount}
                        autoNumFormat={autoNumFormat}
                        lineApproval={lineApproval.filter(
                          (detail: any) =>
                            detail.approver?.EmployeeId === userData.EmployeeId
                        )}
                        t={t}
                        checkInterFace={checkInterFace}
                        interfaceButton={interfaceButton}
                        actionAlert={actionAlert}
                        setButtonType={setButtonType}
                        setEmployeeList={setEmployeeList}
                        employeeList={employeeList}
                        edFont={rishFont}
                        defaultFont={defaultFont}
                      />
                    )}
                    {selectedView === "3" && (
                      <LineApprovalsComponentFix
                        lineApproval={lineApproval}
                        setLineApproval={setLineApproval}
                        employeeList={masterEmployee}
                        signatureList={masterSignature}
                        canEditLineApproval={canEditLineApprove}
                        currentLevel={memoDetail.current_approval_level}
                        memoDetail={memoDetail}
                        t={t}
                        setEmployeeList={setEmployeeList}
                        employee={employeeList}
                        getLineApproveForAmount={getLineApproveForAmount}
                      />
                    )}
                    {selectedView === "4" && (
                      <AttachmentComponent
                        masterATDLFT={masterATDLFT}
                        masterAttachDL={masterAttachDL}
                        listFileAttachDetails={listFileAttachDetails}
                        setListFileAttachDetails={setListFileAttachDetails}
                        fileAttact={fileAttact}
                        setMemoDetail={setMemoDetail}
                        memoDetail={memoDetail}
                        userData={userData}
                        canEditDoc={canEditDoc}
                        listFormNames={listFormNames}
                        checkActionPage={checkActionPage}
                        t={t}
                      />
                    )}
                    {checkActionPage === "edit" && selectedView === "5" && (
                      <HistoryComponent
                        listHistoryDetails={listHistoryDetails}
                        listLineApprove={lineApproval}
                        t={t}
                      />
                    )}
                  </motion.div>
                </AnimatePresence>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default RequestScreenFix;
